"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1764],{

/***/ 79876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P8": function() { return /* binding */ CONTENT; },
/* harmony export */   "Tl": function() { return /* binding */ trackHelpCenter; },
/* harmony export */   "y3": function() { return /* binding */ trackMyTrips; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94738);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66487);





var CONTENT = {
    heading: "Tonight only Deals. Only in the App.",
    subheading: "Discover hotel, flight and rental car deals exclusively in the app. Download today to stay connected with important trip details.",
    successMessage: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        children: "We've sent a link to the number you provided. Happy Savings!"
    }),
    failureMessage: "Please check the number you have entered",
    imageUrl: "https://s1.pclncdn.com/pcln/promotions/app_install/opt-in-app-download.jpg",
    altImageText: "app screenshot",
    placeholderText: "+1 (###) ###-####",
    type: "SMS",
    buttonText: "Send Link"
};
function trackMyTrips() {
    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
        category: _constants_analytics__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_CATEGORY_HOME */ .DG,
        action: "promo trio",
        label: "my trips"
    });
    window.open("https://www.priceline.com/next-profile/trip-lookup");
}
function trackHelpCenter() {
    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
        category: _constants_analytics__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_CATEGORY_HOME */ .DG,
        action: "promo trio",
        label: "help center"
    });
    window.open("https://help.priceline.com/");
}


/***/ }),

/***/ 93860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Label/Label.js
var Label = __webpack_require__(98028);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(9922);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/react-hook-form.es.js
var react_hook_form_es = __webpack_require__(64298);
// EXTERNAL MODULE: ./node_modules/@pcln/date-picker/dist/esm/index.js + 67 modules
var esm = __webpack_require__(32018);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 238 modules
var es = __webpack_require__(67763);
// EXTERNAL MODULE: ./node_modules/isomorphic-config/lib/config.js
var config = __webpack_require__(82197);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/hooks/useTabGroup.ts
var useTabGroup = __webpack_require__(78474);
// EXTERNAL MODULE: ./src/components/DateField.tsx
var DateField = __webpack_require__(43484);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Select/Select.js
var Select = __webpack_require__(16031);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/FormField/FormField.js
var FormField = __webpack_require__(23341);
// EXTERNAL MODULE: ./node_modules/date-fns/locale/en-CA/index.js
var en_CA = __webpack_require__(23654);
var en_CA_default = /*#__PURE__*/__webpack_require__.n(en_CA);
// EXTERNAL MODULE: ./node_modules/date-fns/locale/en-GB/index.js
var en_GB = __webpack_require__(22709);
var en_GB_default = /*#__PURE__*/__webpack_require__.n(en_GB);
// EXTERNAL MODULE: ./node_modules/date-fns/locale/en-US/index.js
var en_US = __webpack_require__(82512);
var en_US_default = /*#__PURE__*/__webpack_require__.n(en_US);
// EXTERNAL MODULE: ./node_modules/date-fns/locale/es/index.js
var locale_es = __webpack_require__(19962);
var es_default = /*#__PURE__*/__webpack_require__.n(locale_es);
// EXTERNAL MODULE: ./node_modules/date-fns/locale/fr/index.js
var fr = __webpack_require__(63126);
var fr_default = /*#__PURE__*/__webpack_require__.n(fr);
// EXTERNAL MODULE: ./node_modules/date-fns/locale/pt/index.js
var pt = __webpack_require__(63086);
var pt_default = /*#__PURE__*/__webpack_require__.n(pt);
// EXTERNAL MODULE: ./node_modules/date-fns/locale/pt-BR/index.js
var pt_BR = __webpack_require__(81333);
var pt_BR_default = /*#__PURE__*/__webpack_require__.n(pt_BR);
;// CONCATENATED MODULE: ./src/components/TimeSelect/dateFnsLocales.ts







var locales = {
    "en-US": (en_US_default()),
    "en-GB": (en_GB_default()),
    "en-CA": (en_CA_default()),
    "pt-BR": (pt_BR_default()),
    pt: (pt_default()),
    es: (es_default()),
    fr: (fr_default())
};
// In RC some locales contain country modifcations. example es-MX. But these may not exist in date-fns so return the language-only value.
var supportedLocale = function(locale) {
    if (locales[locale]) return locale;
    if (locales[locale.substr(0, 2)]) return locale.substr(0, 2);
    return "en-US";
};
var validateLocale = function(aliasLocale) {
    if (!aliasLocale) return "en-US";
    if (aliasLocale === "en") return "en-US";
    var matchedLocale = aliasLocale.match(/([a-z]{2})(?:-?([a-zA-Z]{2})?)/);
    if (!matchedLocale) {
        return "en-US";
    }
    if (matchedLocale && matchedLocale.length && matchedLocale[2] === undefined) {
        return supportedLocale(matchedLocale[1]);
    }
    return supportedLocale(matchedLocale[1].concat("-", matchedLocale[2].toUpperCase()));
};

// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/utils/capitalize-letter.ts
function capitalizeLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

;// CONCATENATED MODULE: ./src/components/TimeSelect/TimeSelect.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  cursor: pointer;\n  height: 56px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-2a6db04f-0"
})(_templateObject(), theme/* theme.colors.white */.rS.colors.white);
var NOON = 24;
var HOURS = [
    "00:00",
    "00:30",
    "01:00",
    "01:30",
    "02:00",
    "02:30",
    "03:00",
    "03:30",
    "04:00",
    "04:30",
    "05:00",
    "05:30",
    "06:00",
    "06:30",
    "07:00",
    "07:30",
    "08:00",
    "08:30",
    "09:00",
    "09:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00",
    "22:30",
    "23:00",
    "23:30"
];
var parseStandardTime = function(time) {
    var ref = (0,_sliced_to_array/* default */.Z)(time.split(":"), 2), hours = ref[0], minutes = ref[1];
    var standardHours = Number(hours) > 12 ? (Number(hours) - 12).toString() : hours;
    return "".concat(standardHours, ":").concat(minutes);
};
var generateTimeSelectOptions = function(locale) {
    var ref, ref1, ref2, ref3, ref4;
    var dateFnsLocale = locales[validateLocale(locale)];
    var am = (ref = dateFnsLocale.localize) === null || ref === void 0 ? void 0 : ref.dayPeriod("am", {
        width: "abbreviated"
    });
    var pm = (ref1 = dateFnsLocale.localize) === null || ref1 === void 0 ? void 0 : ref1.dayPeriod("pm", {
        width: "abbreviated"
    });
    var noon = (ref2 = dateFnsLocale.localize) === null || ref2 === void 0 ? void 0 : ref2.dayPeriod("noon", {
        width: "abbreviated"
    });
    var midnight = (ref3 = dateFnsLocale.localize) === null || ref3 === void 0 ? void 0 : ref3.dayPeriod("midnight", {
        width: "abbreviated"
    });
    var timeFormat = (ref4 = dateFnsLocale.formatLong) === null || ref4 === void 0 ? void 0 : ref4.time({
        width: "short"
    });
    return HOURS.map(function(time, index) {
        var isBeforeNoon = index < NOON;
        var meridiem = isBeforeNoon ? am : pm;
        var label = timeFormat === "HH:mm" ? time : "".concat(parseStandardTime(time), " ").concat(meridiem);
        if (time === "00:00") {
            label = capitalizeLetter(midnight);
        }
        if (time === "12:00") {
            label = capitalizeLetter(noon);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
            value: time,
            label: label,
            children: label
        }, time);
    });
};
var TimeSelect = function(param) {
    var label = param.label, name = param.name, onChange = param.onChange, onDismiss = param.onDismiss, value = param.value;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), tmp = ref.locale, ref1 = tmp === void 0 ? {} : tmp, _localeCode = ref1.localeCode, localeCode = _localeCode === void 0 ? "en-US" : _localeCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                autoHide: true,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                id: name,
                name: name,
                onChange: onChange,
                onDismiss: onDismiss,
                value: value,
                children: generateTimeSelectOptions(localeCode)
            })
        ]
    });
};
/* harmony default export */ var TimeSelect_TimeSelect = (TimeSelect);

// EXTERNAL MODULE: ./src/components/TypeAhead/index.tsx + 13 modules
var TypeAhead = __webpack_require__(21993);
// EXTERNAL MODULE: ./src/components/SearchFormButton/index.tsx
var SearchFormButton = __webpack_require__(17975);
// EXTERNAL MODULE: ./src/components/CalenderWrapperBox.styled.ts
var CalenderWrapperBox_styled = __webpack_require__(2850);
// EXTERNAL MODULE: ./src/components/ShadowEffect.tsx
var ShadowEffect = __webpack_require__(10843);
// EXTERNAL MODULE: ./src/components/Popover.tsx + 2 modules
var Popover = __webpack_require__(57812);
// EXTERNAL MODULE: ./src/utils/date-helper.tsx
var date_helper = __webpack_require__(68511);
// EXTERNAL MODULE: ./src/components/BundleAndSave/BundleAndSave.tsx
var BundleAndSave = __webpack_require__(18103);
// EXTERNAL MODULE: ./src/components/TravelerSelection/TravelerSelection.tsx + 9 modules
var TravelerSelection = __webpack_require__(47941);
// EXTERNAL MODULE: ./src/components/TravelerSelection/constants.ts
var constants = __webpack_require__(45588);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var utils_analytics = __webpack_require__(94738);
;// CONCATENATED MODULE: ./src/utils/prefetchApp.ts
/**
 * Read the build manifest for an app. Use this to insert link
 * tags into the head of document so that browser can prefetch
 * the app that the customer will be sent to next. Improves
 * performance by letting the browser download ahead of time.
 */ 


var insertPrefetchLinks = function(data) {
    var head = document.querySelector("head");
    if (head !== null) {
        Object.values(data).forEach(function(bundle) {
            var link = document.createElement("link");
            link.rel = "prefetch";
            link.href = bundle;
            head.appendChild(link);
        });
    }
};
var retrieveManifest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(manifestUrl) {
        var response, manifest, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(manifestUrl)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    manifest = _state.sent();
                    return [
                        2,
                        Object.values(manifest).reduce(function(result, entry, key) {
                            if (entry.match(/\.js$/)) {
                                var theResult = result;
                                theResult[key] = entry;
                            }
                            return result;
                        }, {})
                    ];
                case 3:
                    error = _state.sent();
                    utils_analytics/* default.logError */.Z.logError({
                        message: "Failed to load ".concat(manifestUrl, " for prefetch")
                    });
                    return [
                        2,
                        {}
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function retrieveManifest(manifestUrl) {
        return _ref.apply(this, arguments);
    };
}();


// EXTERNAL MODULE: ./src/components/Cars/constants.ts
var Cars_constants = __webpack_require__(55633);
// EXTERNAL MODULE: ./src/components/Cars/SearchForm/utils.ts
var utils = __webpack_require__(60837);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/components/Cars/SearchForm/validation.ts



var CHILD_AGE_REQUIRED = "Please enter children's age";
var DATE_RANGE_ERROR = "Please make sure the drop-off date is the same or later than the pick-up date";
var DROPOFF_LOCATION_REQUIRED = "Please select a drop-off location";
var INVALID_DATE = "Please select a valid date";
var INVALID_DATES = "Please select valid dates";
var HOTEL_LOCATION_REQUIRED = "Please enter a valid location";
var PICKUP_LOCATION_REQUIRED = "Please select a pick-up location";
var ROOM_CAPACITY_ERROR = "Rooms accommodate up to 4 people. You may need additional rooms for your group";
var TRAVELERS_PER_ROOM = 4;
function isChildrenAgeProvided() {
    var _parent = this.parent, childrenAges = _parent.childrenAges, childrenCount = _parent.childrenCount;
    return childrenCount === childrenAges.length;
}
function isWithinDateRange() {
    var _parent = this.parent, endDate = _parent.endDate, startDate = _parent.startDate;
    var formattedStartDate = (0,date_helper/* formatDate */.p6)(startDate);
    var formattedEndDate = (0,date_helper/* formatDate */.p6)(endDate);
    return new Date(formattedStartDate) <= new Date(formattedEndDate);
}
function isWithinRoomCapacity() {
    var _parent = this.parent, adultCount = _parent.adultCount, roomCount = _parent.roomCount, childrenCount = _parent.childrenCount;
    var travelerCount = adultCount + childrenCount;
    var allowedTravelerCount = roomCount * TRAVELERS_PER_ROOM;
    return travelerCount <= allowedTravelerCount;
}
var searchFormSchema = yup_es/* object */.Ry().shape({
    childrenAges: yup_es/* array */.IX().when([
        "childrenCount",
        "tripType"
    ], {
        is: function(childrenCount, tripType) {
            return tripType.includes(Cars_constants/* STAY */.hQ) && childrenCount > 0;
        },
        then: yup_es/* array */.IX().test({
            message: CHILD_AGE_REQUIRED,
            name: "childrenAges",
            test: isChildrenAgeProvided
        }),
        otherwise: yup_es/* array */.IX().nullable()
    }),
    endDate: yup_es/* string */.Z_().when("tripType", {
        is: function(tripType) {
            return tripType === Cars_constants/* DRIVE */.cv;
        },
        then: yup_es/* string */.Z_().required(INVALID_DATE).when("startDate", {
            is: function(startDate) {
                return startDate !== "";
            },
            then: yup_es/* string */.Z_().test({
                message: DATE_RANGE_ERROR,
                name: "endDate",
                test: isWithinDateRange
            }),
            otherwise: yup_es/* string */.Z_().nullable()
        }),
        otherwise: yup_es/* string */.Z_().nullable()
    }),
    endLocation: yup_es/* object */.Ry().nullable().when("oneWay", {
        is: true,
        then: yup_es/* object */.Ry().nullable().required(DROPOFF_LOCATION_REQUIRED),
        otherwise: yup_es/* object */.Ry().nullable()
    }).when("tripType", {
        is: function(tripType) {
            return tripType.includes(Cars_constants/* STAY */.hQ);
        },
        then: yup_es/* object */.Ry().nullable().required(HOTEL_LOCATION_REQUIRED),
        otherwise: yup_es/* object */.Ry().nullable()
    }),
    hotelEndDate: yup_es/* string */.Z_().when("tripType", {
        is: function(tripType) {
            return tripType.includes(Cars_constants/* STAY */.hQ);
        },
        then: yup_es/* string */.Z_().required(INVALID_DATES),
        otherwise: yup_es/* string */.Z_().nullable()
    }),
    hotelStartDate: yup_es/* string */.Z_().when("tripType", {
        is: function(tripType) {
            return tripType.includes(Cars_constants/* STAY */.hQ);
        },
        then: yup_es/* string */.Z_().required(INVALID_DATES),
        otherwise: yup_es/* string */.Z_().nullable()
    }),
    roomCount: yup_es/* number */.Rx().when("tripType", {
        is: function(tripType) {
            return tripType.includes(Cars_constants/* STAY */.hQ);
        },
        then: yup_es/* number */.Rx().test({
            message: ROOM_CAPACITY_ERROR,
            name: "roomCount",
            test: isWithinRoomCapacity
        }),
        otherwise: yup_es/* number */.Rx().nullable()
    }),
    startDate: yup_es/* string */.Z_().when("tripType", {
        is: function(tripType) {
            return tripType === Cars_constants/* DRIVE */.cv;
        },
        then: yup_es/* string */.Z_().required(INVALID_DATE),
        otherwise: yup_es/* string */.Z_().nullable()
    }),
    startLocation: yup_es/* object */.Ry().nullable().when("tripType", {
        is: function(tripType) {
            return tripType === Cars_constants/* DRIVE */.cv;
        },
        then: yup_es/* object */.Ry().nullable().required(PICKUP_LOCATION_REQUIRED),
        otherwise: yup_es/* object */.Ry().nullable()
    })
});
/* harmony default export */ var validation = (searchFormSchema);

;// CONCATENATED MODULE: ./src/components/Cars/SearchForm/Form.tsx
/* eslint-disable @typescript-eslint/unbound-method */ // eslint-disable can be removed after upgrade to react-hook-form v7 - https://github.com/react-hook-form/react-hook-form/issues/2887




























var SubmitButtonContainer = function(param) {
    var watchTripType = param.watchTripType;
    var ref;
    var ref1 = (0,react.useContext)(BootstrapDataContext/* default */.Z), webstats = ref1.webstats, customer = ref1.customer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: [
            1,
            null,
            1 / 2
        ],
        pl: [
            0,
            null,
            2
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormButton/* default */.Z, {
                buttonText: "Find Your Car",
                "data-testid": "HOME_RENTALCARS_SUBMIT_BUTTON",
                "data-rudder-event": true,
                "data-sub-type": "search",
                "data-source": "homepage",
                "data-parent-product": "DRIVE",
                "data-child-product": (ref = watchTripType.split(":")) === null || ref === void 0 ? void 0 : ref[1],
                "data-cguid": webstats.clientGUID,
                "data-email-address": customer.emailAddress
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    color: "text",
                    textAlign: "center",
                    fontSize: 0,
                    children: "Book a car with free cancellation for flexibility"
                })
            })
        ]
    });
};
function Form(param) {
    var onSubmit = param.onSubmit;
    var isMobile = (0,react.useContext)(BootstrapDataContext/* default */.Z).isMobile;
    var ref = (0,useTabGroup/* default */.Z)(), registerTabElement = ref.registerTabElement, focusNextElement = ref.focusNextElement;
    var ref1 = (0,react.useState)(false), isStartCalendarOpen = ref1[0], setIsStartCalendarOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isEndCalendarOpen = ref2[0], setIsEndCalendarOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isHotelCalendarOpen = ref3[0], setIsHotelCalendarOpen = ref3[1];
    var ref4 = (0,react.useState)(false), dsrManifestFetched = ref4[0], setDSRManifestFetched = ref4[1];
    var ref5 = (0,react.useState)(false), oneWayDropoff = ref5[0], setOneWayDropoff = ref5[1];
    var ref6 = (0,react_hook_form_es/* useForm */.cI)({
        defaultValues: utils/* initialState */.E3,
        mode: "onSubmit",
        validationSchema: validation,
        reValidateMode: "onChange"
    }), clearError = ref6.clearError, errors = ref6.errors, handleSubmit = ref6.handleSubmit, register = ref6.register, setValue = ref6.setValue, triggerValidation = ref6.triggerValidation, unregister = ref6.unregister, watch = ref6.watch;
    var onOneWayDropoffChange = function(e) {
        setOneWayDropoff(e.target.checked);
        setValue("oneWay", e.target.checked);
    };
    (0,react.useEffect)(function() {
        utils/* fields.forEach */.XU.forEach(function(name) {
            register({
                name: name
            });
        });
        return function() {
            utils/* fields.forEach */.XU.forEach(function(name) {
                unregister(name);
            });
        };
    }, [
        register,
        unregister
    ]);
    var ref7 = watch(), watchAdultCount = ref7.adultCount, watchChildrenAges = ref7.childrenAges, watchChildrenCount = ref7.childrenCount, watchEndDate = ref7.endDate, watchEndTime = ref7.endTime, watchEndLocation = ref7.endLocation, watchHotelEndDate = ref7.hotelEndDate, watchHotelStartDate = ref7.hotelStartDate, watchOneWay = ref7.oneWay, watchRoomCount = ref7.roomCount, watchStartDate = ref7.startDate, watchStartTime = ref7.startTime, watchStartLocation = ref7.startLocation, watchTripType = ref7.tripType;
    (0,react.useEffect)(function() {
        triggerValidation("childrenAges");
    }, [
        triggerValidation,
        watchStartLocation,
        watchEndLocation,
        watchChildrenAges,
        watchAdultCount,
        watchChildrenCount
    ]);
    (0,react.useEffect)(function() {
        clearError("endDate");
    }, [
        clearError,
        watchEndDate
    ]);
    (0,react.useEffect)(function() {
        clearError("endLocation");
    }, [
        clearError,
        watchEndLocation
    ]);
    (0,react.useEffect)(function() {
        clearError("hotelStartDate");
    }, [
        clearError,
        watchHotelStartDate
    ]);
    (0,react.useEffect)(function() {
        clearError("roomCount");
    }, [
        clearError,
        watchRoomCount
    ]);
    (0,react.useEffect)(function() {
        clearError("startDate");
    }, [
        clearError,
        watchStartDate
    ]);
    (0,react.useEffect)(function() {
        clearError("startLocation");
    }, [
        clearError,
        watchStartLocation
    ]);
    (0,react.useEffect)(function() {
        triggerValidation("roomCount");
    }, [
        triggerValidation,
        watchChildrenCount,
        watchRoomCount,
        watchAdultCount,
        watchTripType
    ]);
    var hasHotel = watchTripType.includes(Cars_constants/* STAY */.hQ);
    var pickupCalendarInput = (0,react.useRef)(null);
    var dropoffCalendarInput = (0,react.useRef)(null);
    var handleFocus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formTarget) {
            var isNotAddHotel, isNotUndefined, fetchDsrManifest, dsrManifest, links;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNotAddHotel = formTarget.target.id !== "add-a-hotel-checkbox";
                        isNotUndefined = formTarget.target.id !== "";
                        fetchDsrManifest = !dsrManifestFetched && isNotAddHotel && isNotUndefined && !hasHotel;
                        if (!fetchDsrManifest) return [
                            3,
                            2
                        ];
                        dsrManifest = (config_default()).client.prefetch.dsr;
                        return [
                            4,
                            retrieveManifest(dsrManifest)
                        ];
                    case 1:
                        links = _state.sent();
                        insertPrefetchLinks(links);
                        setDSRManifestFetched(true);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFocus(formTarget) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        "aria-label": "rental-car-search-form",
        "data-testid": "form",
        onFocus: handleFocus,
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexWrap: "wrap",
                mx: -2,
                children: [
                    !hasHotel && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                        forProperty: "startLocation",
                        width: watchOneWay ? [
                            1,
                            null,
                            1 / 2
                        ] : 1,
                        px: 2,
                        mb: [
                            0,
                            null,
                            2
                        ],
                        children: function(param) {
                            var disableShadowState = param.disableShadowState;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                searchProduct: "cars",
                                errors: errors,
                                defaultSelectedItem: watchStartLocation,
                                disableShadowState: disableShadowState,
                                focusNextElement: focusNextElement,
                                label: "City, Airport or Address",
                                placeholder: "City, Airport or Address",
                                ref: registerTabElement,
                                searchKey: "startLocation",
                                setValue: setValue
                            });
                        }
                    }),
                    (hasHotel || watchOneWay) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                        forProperty: "endLocation",
                        px: 2,
                        width: !hasHotel && watchOneWay ? [
                            1,
                            null,
                            1 / 2
                        ] : 1,
                        mb: [
                            -2,
                            null,
                            2
                        ],
                        children: function(param) {
                            var disableShadowState = param.disableShadowState;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                searchProduct: hasHotel ? "packagesDestination" : "cars",
                                defaultSelectedItem: watchEndLocation,
                                disableShadowState: disableShadowState,
                                errors: errors,
                                focusNextElement: focusNextElement,
                                label: "City, Airport or Address",
                                placeholder: "City, Airport or Address",
                                ref: registerTabElement,
                                searchKey: "endLocation",
                                setValue: setValue
                            });
                        }
                    })
                ]
            }),
            !hasHotel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                width: [
                    1,
                    null,
                    "auto"
                ],
                mb: -1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label/* default */.Z, {
                    htmlFor: "oneWay",
                    fontSize: [
                        0,
                        null,
                        "10px"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            id: "oneWay",
                            name: "oneWay",
                            "data-testid": "oneWay",
                            checked: oneWayDropoff,
                            onChange: onOneWayDropoffChange,
                            ref: register,
                            onClick: function() {
                                utils_analytics/* default.fireEvent */.Z.fireEvent({
                                    action: "Field Click",
                                    category: analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                                    label: "RentalCars - oneway click"
                                });
                            }
                        }),
                        "Return car to a different location"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                flexWrap: [
                    "wrap",
                    null,
                    null,
                    null,
                    "nowrap"
                ],
                mt: 2,
                mx: -2,
                mb: [
                    -2,
                    null,
                    0
                ],
                children: [
                    !hasHotel && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                mt: [
                                    2,
                                    null,
                                    0
                                ],
                                px: 2,
                                mb: [
                                    0,
                                    null,
                                    3
                                ],
                                width: [
                                    1 / 2,
                                    null,
                                    null,
                                    null,
                                    1 / 4
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                    forProperty: "startDate",
                                    children: function(param) {
                                        var disableShadowState = param.disableShadowState;
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                            "data-calendar": true,
                                            domSelectorForVisuallyContainedElement: Cars_constants/* CALENDAR_POPOVER_SELECTOR */.k7,
                                            onDismiss: function() {
                                                setIsStartCalendarOpen(false);
                                                disableShadowState();
                                            },
                                            open: isStartCalendarOpen,
                                            position: "left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                    "aria-expanded": isStartCalendarOpen ? "true" : "false",
                                                    "data-testid": "HOME_RENTALCARS_STARTDATE_INPUT",
                                                    error: (ref = errors.startDate) === null || ref === void 0 ? void 0 : ref.message,
                                                    label: "Pick-up",
                                                    id: "startDate",
                                                    ref: pickupCalendarInput,
                                                    m: 0,
                                                    name: "startDate",
                                                    onFocus: function() {
                                                        setIsStartCalendarOpen(true);
                                                    },
                                                    placeholder: "Pick-up",
                                                    type: "text",
                                                    value: (0,date_helper/* formatDate */.p6)(watchStartDate)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                    allowSameDay: true,
                                                    endDate: watchEndDate,
                                                    roundedCorners: true,
                                                    monthWidthPx: 350,
                                                    onChange: function(e, param) {
                                                        var startDate = param.startDate;
                                                        if (startDate) {
                                                            setValue("startDate", startDate);
                                                            setValue("endDate", (0,date_helper/* addFormattedDays */.r2)(startDate, 1, "yyyyMMdd"));
                                                            setIsStartCalendarOpen(false);
                                                            disableShadowState();
                                                        }
                                                    },
                                                    onDismiss: function() {
                                                        setIsStartCalendarOpen(false);
                                                        disableShadowState();
                                                    },
                                                    scrollDate: watchStartDate,
                                                    selectTwoDates: false,
                                                    startDate: watchStartDate,
                                                    useDefaultFooter: true
                                                })
                                            ]
                                        }, "startDate");
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                px: 2,
                                mb: [
                                    2,
                                    null,
                                    3
                                ],
                                width: [
                                    1 / 2,
                                    null,
                                    null,
                                    null,
                                    1 / 4
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                    forProperty: "startTime",
                                    children: function(param) {
                                        var disableShadowState = param.disableShadowState;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeSelect_TimeSelect, {
                                            "data-testid": "HOME_RENTALCARS_STARTTIME_SELECT",
                                            label: "Pick-up Time",
                                            name: "startTime",
                                            onChange: function(e) {
                                                var endTime = (0,es/* pathOr */.pMU)("", [
                                                    "currentTarget",
                                                    "value"
                                                ], e);
                                                setValue("startTime", endTime);
                                                setValue("endTime", endTime);
                                                disableShadowState();
                                            },
                                            onDismiss: function() {
                                                disableShadowState();
                                            },
                                            value: watchStartTime
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                px: 2,
                                mb: 3,
                                width: [
                                    1 / 2,
                                    null,
                                    null,
                                    null,
                                    1 / 4
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                    forProperty: "endDate",
                                    children: function(param) {
                                        var disableShadowState = param.disableShadowState;
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                            "data-calendar": true,
                                            domSelectorForVisuallyContainedElement: Cars_constants/* CALENDAR_POPOVER_SELECTOR */.k7,
                                            open: isEndCalendarOpen,
                                            onDismiss: function() {
                                                setIsEndCalendarOpen(false);
                                                disableShadowState();
                                            },
                                            position: "left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                    "aria-expanded": isEndCalendarOpen ? "true" : "false",
                                                    "data-testid": "HOME_RENTALCARS_ENDDATE_INPUT",
                                                    error: (ref = errors.endDate) === null || ref === void 0 ? void 0 : ref.message,
                                                    id: "endDate",
                                                    ref: dropoffCalendarInput,
                                                    label: "Drop-off",
                                                    m: 0,
                                                    name: "endDate",
                                                    onFocus: function() {
                                                        setIsEndCalendarOpen(true);
                                                    },
                                                    placeholder: "Drop-off",
                                                    type: "text",
                                                    value: (0,date_helper/* formatDate */.p6)(watchEndDate)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                        allowSameDay: true,
                                                        endDate: watchEndDate,
                                                        roundedCorners: true,
                                                        monthWidthPx: 350,
                                                        onChange: function(e, param) {
                                                            var startDate = param.startDate;
                                                            if (startDate) {
                                                                setValue("endDate", startDate);
                                                                setIsEndCalendarOpen(false);
                                                                disableShadowState();
                                                            }
                                                        },
                                                        onDismiss: function() {
                                                            setIsEndCalendarOpen(false);
                                                            disableShadowState();
                                                        },
                                                        position: "left",
                                                        scrollDate: watchEndDate,
                                                        selectTwoDates: false,
                                                        startDate: watchStartDate,
                                                        useDefaultFooter: true
                                                    })
                                                })
                                            ]
                                        }, "endDate");
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                px: 2,
                                mb: [
                                    4,
                                    null,
                                    3
                                ],
                                width: [
                                    1 / 2,
                                    null,
                                    null,
                                    null,
                                    1 / 4
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                    forProperty: "endTime",
                                    children: function(param) {
                                        var disableShadowState = param.disableShadowState;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeSelect_TimeSelect, {
                                            "data-testid": "HOME_RENTALCARS_ENDTIME_SELECT",
                                            label: "Drop-off Time",
                                            name: "endTime",
                                            onChange: function(e) {
                                                var endTime = (0,es/* pathOr */.pMU)("", [
                                                    "currentTarget",
                                                    "value"
                                                ], e);
                                                setValue("endTime", endTime);
                                                disableShadowState();
                                            },
                                            onDismiss: function() {
                                                disableShadowState();
                                            },
                                            value: watchEndTime
                                        });
                                    }
                                })
                            })
                        ]
                    }),
                    hasHotel && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                flexWrap: "wrap",
                                mb: [
                                    0,
                                    null,
                                    3
                                ],
                                width: [
                                    1,
                                    null,
                                    1 / 2
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                    id: "rc-with-hotel-dates",
                                    px: 2,
                                    width: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                        enabled: !isMobile,
                                        forProperty: "startDate",
                                        children: function(param) {
                                            var disableShadowState = param.disableShadowState;
                                            var ref, ref1;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                "data-calendar": true,
                                                domSelectorForVisuallyContainedElement: Cars_constants/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                open: isHotelCalendarOpen,
                                                onDismiss: function() {
                                                    setIsHotelCalendarOpen(false);
                                                    disableShadowState();
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                        "aria-expanded": isHotelCalendarOpen ? "true" : "false",
                                                        error: ((ref = errors.hotelStartDate) === null || ref === void 0 ? void 0 : ref.message) || ((ref1 = errors.hotelEndDate) === null || ref1 === void 0 ? void 0 : ref1.message) || "",
                                                        label: "Departing - Returning",
                                                        name: "hotelDates",
                                                        onFocus: function() {
                                                            setIsHotelCalendarOpen(true);
                                                        },
                                                        value: (0,date_helper/* getPackagesDateRange */.Q0)({
                                                            startDate: watchHotelStartDate,
                                                            endDate: watchHotelEndDate
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                        endDate: watchHotelEndDate,
                                                        roundedCorners: true,
                                                        monthWidthPx: 350,
                                                        onChange: function(e, param) {
                                                            var startDate = param.startDate, endDate = param.endDate;
                                                            if (startDate && endDate) {
                                                                setIsHotelCalendarOpen(false);
                                                                disableShadowState();
                                                            }
                                                            setValue("hotelStartDate", startDate || "");
                                                            setValue("hotelEndDate", endDate || "");
                                                        },
                                                        onDismiss: function() {
                                                            setIsHotelCalendarOpen(false);
                                                            disableShadowState();
                                                        },
                                                        startDate: watchHotelStartDate,
                                                        useDefaultFooter: true
                                                    })
                                                ]
                                            });
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                flexWrap: "wrap",
                                mb: [
                                    4,
                                    null,
                                    3
                                ],
                                px: 2,
                                width: [
                                    1,
                                    null,
                                    1 / 2
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                    alternativeBlurHandling: true,
                                    forProperty: "travelers-selection-readonly-input",
                                    children: function(param) {
                                        var disableShadowState = param.disableShadowState;
                                        var ref, ref1;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TravelerSelection/* default */.Z, {
                                            adultCount: watchAdultCount,
                                            childrenAges: watchChildrenAges,
                                            childrenCount: watchChildrenCount,
                                            disableShadowState: disableShadowState,
                                            disclaimer: constants/* VP_DISCLAIMER */.sP,
                                            error: ((ref = errors === null || errors === void 0 ? void 0 : errors.childrenAges) === null || ref === void 0 ? void 0 : ref.message) || (errors === null || errors === void 0 ? void 0 : (ref1 = errors.roomCount) === null || ref1 === void 0 ? void 0 : ref1.message) || "",
                                            infantCount: 0,
                                            isMobile: isMobile,
                                            onDoneButtonClick: disableShadowState,
                                            roomCount: watchRoomCount,
                                            setValue: setValue,
                                            showChildAgeSelectors: true,
                                            showInfantMenuItem: false,
                                            showRoomMenuItem: true,
                                            showSubLabel: false,
                                            showYouthMenuItem: false,
                                            youthCount: 0
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        width: [
                            1,
                            null,
                            1 / 2
                        ],
                        height: [
                            "40px",
                            null,
                            "56px"
                        ],
                        pr: [
                            0,
                            null,
                            2
                        ],
                        mb: [
                            3,
                            null,
                            0
                        ],
                        mt: [
                            -1,
                            null,
                            0
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BundleAndSave/* default */.Z, {
                            category: analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                            label: "Bundle + Save",
                            productOptions: Cars_constants/* ADD_PRODUCT_OPTIONS */.Po,
                            setValue: setValue,
                            tripType: watchTripType
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButtonContainer, {
                        watchTripType: watchTripType
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 60837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "Rh": function() { return /* binding */ handleSubmitForCars; },
/* harmony export */   "XU": function() { return /* binding */ fields; }
/* harmony export */ });
/* unused harmony export formatCarsURL */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57809);
/* harmony import */ var _shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29735);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94738);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66487);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55633);






var initialState = {
    adultCount: 2,
    childrenAges: [],
    childrenCount: 0,
    endDate: "",
    endLocation: null,
    endTime: "12:00",
    hotelEndDate: "",
    hotelStartDate: "",
    oneWay: false,
    roomCount: 1,
    startDate: "",
    startLocation: null,
    startTime: "12:00",
    tripType: _constants__WEBPACK_IMPORTED_MODULE_4__/* .DRIVE */ .cv
};
var fields = [
    "adultCount",
    "childrenAges",
    "childrenCount",
    "endDate",
    "endLocation",
    "endTime",
    "hotelEndDate",
    "hotelStartDate",
    "oneWay",
    "roomCount",
    "startDate",
    "startLocation",
    "startTime",
    "tripType"
];
function formatCarsPartnerLocation(location) {
    if (!location) return null;
    if (location.type === "AIRPORT" || location.type === "PARTNER_LOC") {
        return location.id;
    }
    return encodeURI(location.itemName);
}
function formatCarsURL(param) {
    var endDate = param.endDate, endLocation = param.endLocation, _endTime = param.endTime, endTime = _endTime === void 0 ? "12:00" : _endTime, _oneWay = param.oneWay, oneWay = _oneWay === void 0 ? false : _oneWay, startDate = param.startDate, startLocation = param.startLocation, _startTime = param.startTime, startTime = _startTime === void 0 ? "12:00" : _startTime;
    var formattedStartLocation = formatCarsPartnerLocation(startLocation);
    var formattedEndLocation = oneWay ? formatCarsPartnerLocation(endLocation) : formattedStartLocation;
    return [
        "/drive/search/r",
        formattedStartLocation,
        formattedEndLocation,
        "".concat(startDate, "-").concat(startTime),
        "".concat(endDate, "-").concat(endTime),
        "list"
    ].join("/");
}
function handleSubmitForCars(values) {
    var adultCount = values.adultCount, childrenAges = values.childrenAges, childrenCount = values.childrenCount, endLocation = values.endLocation, hotelEndDate = values.hotelEndDate, hotelStartDate = values.hotelStartDate, roomCount = values.roomCount, tripType = values.tripType;
    var multiOccFields = {
        adultCount: adultCount,
        childrenCount: childrenCount,
        childrenAges: childrenAges
    };
    var isPackageSearch = tripType.includes(_constants__WEBPACK_IMPORTED_MODULE_4__/* .STAY */ .hQ);
    if (isPackageSearch) {
        var basePackageSearchDetails = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            endLocationObject: endLocation,
            endDate: hotelEndDate,
            startDate: hotelStartDate,
            isPartialStayDateValid: false,
            roomCount: Number(roomCount),
            tripType: tripType
        }, multiOccFields);
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: "Car Search Button (With Hotel)",
            category: _constants_analytics__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_CATEGORY_HOME */ .DG,
            label: "Valid"
        });
        (0,_shared_utils_packages_search__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(basePackageSearchDetails);
    } else {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].fireEvent */ .Z.fireEvent({
            action: "Car Search Button",
            category: _constants_analytics__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_CATEGORY_HOME */ .DG,
            label: "Valid"
        });
        var url = formatCarsURL(values);
        window.open(url);
    }
    (0,_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__/* .persistSearchData */ .al)(_shared_utils_local_forage_helper__WEBPACK_IMPORTED_MODULE_1__/* .CAR_SEARCH_DATA */ .xj, values);
}


/***/ }),

/***/ 55633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Po": function() { return /* binding */ ADD_PRODUCT_OPTIONS; },
/* harmony export */   "cv": function() { return /* binding */ DRIVE; },
/* harmony export */   "hQ": function() { return /* binding */ STAY; },
/* harmony export */   "k7": function() { return /* binding */ CALENDAR_POPOVER_SELECTOR; }
/* harmony export */ });
/* unused harmony exports DRIVE_STAY, RENTAL_CAR_PRODUCT_TYPE, partnerInfo, showPartnersDesktop, showPartnersMobile */
var STAY = "STAY";
var DRIVE = "DRIVE";
var DRIVE_STAY = "DRIVE:STAY";
var RENTAL_CAR_PRODUCT_TYPE = "cars";
var ADD_PRODUCT_OPTIONS = [
    {
        name: "hotel",
        type: STAY,
        label: "Add a hotel",
        id: "add-a-hotel-checkbox"
    }
];
var CALENDAR_POPOVER_SELECTOR = '[aria-label="Calendar navigation tooltip"]';
var partnerInfo = [
    {
        name: "ACE",
        symbol: "AC"
    },
    {
        name: "Advantage",
        symbol: "AD"
    },
    {
        name: "Alamo",
        symbol: "AL"
    },
    {
        name: "Avis",
        symbol: "AV"
    },
    {
        name: "Budget",
        symbol: "BU"
    },
    {
        name: "Driving Force",
        symbol: "DF"
    },
    {
        name: "Europcar",
        symbol: "EP"
    },
    {
        name: "EASIRENT.com",
        symbol: "ES"
    },
    {
        name: "Enterprise",
        symbol: "ET"
    },
    {
        name: "American Rent A Car",
        symbol: "EX"
    },
    {
        name: "Economy",
        symbol: "EY"
    },
    {
        name: "EZ Rent A Car",
        symbol: "EZ"
    },
    {
        name: "Firefly",
        symbol: "FF"
    },
    {
        name: "Foco",
        symbol: "Foco"
    },
    {
        name: "Fox",
        symbol: "FX"
    },
    {
        name: "Green Motion",
        symbol: "GI"
    },
    {
        name: "Hertz",
        symbol: "HZ"
    },
    {
        name: "Localiza",
        symbol: "Localiza"
    },
    {
        name: "Movida",
        symbol: "Movida"
    },
    {
        name: "Midway",
        symbol: "MW"
    },
    {
        name: "Mex Rent A Car",
        symbol: "MX"
    },
    {
        name: "National",
        symbol: "NA"
    },
    {
        name: "Next Car",
        symbol: "NC"
    },
    {
        name: "NU",
        symbol: "NU"
    },
    {
        name: "Routes",
        symbol: "RO"
    },
    {
        name: "State Van Rental",
        symbol: "SR"
    },
    {
        name: "U-Save",
        symbol: "SV"
    },
    {
        name: "Sixt",
        symbol: "SX"
    },
    {
        name: "Unidas",
        symbol: "Unidas"
    },
    {
        name: "AVR",
        symbol: "VR"
    },
    {
        name: "Payless",
        symbol: "ZA"
    },
    {
        name: "Dollar",
        symbol: "ZR"
    },
    {
        name: "Thrifty",
        symbol: "ZT"
    }
];
var showPartnersDesktop = (/* unused pure expression or super */ null && ([
    "BU",
    "HZ",
    "AV",
    "ET",
    "ZR",
    "ZT",
    "AL",
    "FX",
    "SX",
    "NA",
    "AC",
    "ZA",
    "EY",
    "NU",
    "RO",
    "ES",
    "AD",
    "NC",
    "MW",
    "GI",
    "MX",
    "SV",
    "VR",
    "EP",
    "DF",
    "EX",
    "FF",
    "SR"
]));
var showPartnersMobile = (/* unused pure expression or super */ null && ([
    "HZ",
    "AV",
    "BU",
    "ET",
    "NA",
    "ZR",
    "AL",
    "EP",
    "SX"
]));


/***/ }),

/***/ 90020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CrossSell; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/highlightedFlex/HighlightedFlex.js
var HighlightedFlex = __webpack_require__(93894);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js
var differenceInCalendarDays = __webpack_require__(92300);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/isomorphic-config/lib/config.js
var config = __webpack_require__(82197);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@pcln/config/client.js
var client = __webpack_require__(1918);
var client_default = /*#__PURE__*/__webpack_require__.n(client);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/FlightsFill.js
var FlightsFill = __webpack_require__(75749);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/CarsFill.js
var CarsFill = __webpack_require__(40165);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/HotelsFill.js
var HotelsFill = __webpack_require__(28845);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
;// CONCATENATED MODULE: ./src/utils/clean-slashes.ts
function cleanSlashes(urlString) {
    return urlString.replace(/(^\/)|(\/$)/g, "");
}

;// CONCATENATED MODULE: ./src/components/CrossSell/types.ts
var Product = {
    Flight: 1,
    Hotel: 5,
    Car: 8
};

;// CONCATENATED MODULE: ./src/components/CrossSell/utils.ts











var _hosts;
var hosts = (_hosts = (client_default()).hosts) !== null && _hosts !== void 0 ? _hosts : {};
var baseUrl = hosts.baseUrl || "/";
var baseUrlSecure = hosts.baseUrlSecure || "/";
var _services;
var services = (_services = (client_default()).services) !== null && _services !== void 0 ? _services : {};
var itineraryServiceConfig = (config_default()).client["itinerary-service"];
var getLinkUri = function(serviceName, endpoint) {
    var service = services[serviceName];
    if (!service) {
        throw new Error("service ".concat(serviceName, " not configured"));
    }
    var base = service.secure ? baseUrlSecure : baseUrl;
    return "".concat(cleanSlashes(base), "/").concat(cleanSlashes(service.uri)).concat(endpoint ? "/".concat(cleanSlashes(endpoint)) : "");
};
var PCLN_ITINERARY_SERVICE_URL = itineraryServiceConfig.url || getLinkUri("itinerary-service", "graph");
var PCLN_ITINERARY_SERVICE_TIMEOUT = itineraryServiceConfig.timeout;
var serviceOptions = {
    url: PCLN_ITINERARY_SERVICE_URL,
    method: "POST",
    timeout: PCLN_ITINERARY_SERVICE_TIMEOUT
};
function buildContent(booking) {
    var startDate = (0,parseISO/* default */.Z)(booking.travelStartDateTime);
    var endDate = (0,parseISO/* default */.Z)(booking.travelEndDateTime);
    var formattedDate = "".concat((0,format/* default */.Z)(startDate, "EEE, MMM dd"), " - ").concat((0,format/* default */.Z)(endDate, "EEE, MMM dd"));
    var hotelsXSellUrl = function(destination, start, end) {
        return "/relax/in/".concat(destination, "/from/").concat((0,format/* default */.Z)(start, "yyyyMMdd"), "/to/").concat((0,format/* default */.Z)(end, "yyyyMMdd"), "/rooms/1");
    };
    switch(booking.productId){
        case Product.Hotel:
            {
                var checkInDate = (0,parseISO/* default */.Z)(booking.utcCheckInDateTime);
                return {
                    product: "hotel",
                    xSellMessaging: "Your hotel booking unlocks up to 40% off rental cars",
                    xSellTarget: "Rental Cars",
                    date: formattedDate,
                    offerToken: booking.offerToken,
                    headline: booking.destinationCity,
                    subHeadline: "Check-in on ".concat((0,format/* default */.Z)(checkInDate, "EEE, MMM dd")),
                    xSellUrl: "/drive/search/r/".concat(booking.destinationCity, ",").concat(booking.destinationCountryCode, "/").concat(booking.destinationCity, ",").concat(booking.destinationCountryCode, "/").concat((0,format/* default */.Z)(startDate, "yyyyMMdd"), "-12:00/").concat((0,format/* default */.Z)(endDate, "yyyyMMdd"), "-12:00/list")
                };
            }
        case Product.Flight:
            {
                var destination = booking.destinationCity || booking.destinationLocationCode;
                var isSameDay = (0,differenceInCalendarDays/* default */.Z)(endDate, startDate) < 1;
                return {
                    product: "flight",
                    xSellMessaging: "Your flight booking unlocks VIP hotel deals of up to 40% off",
                    xSellTarget: "Hotels",
                    offerToken: booking.offerToken,
                    date: formattedDate,
                    headline: "".concat(booking.originLocationCode, " - ").concat(booking.destinationLocationCode),
                    subHeadline: "Departs ".concat((0,format/* default */.Z)(startDate, "EEE, MMM dd 'at' h:mm a")),
                    xSellUrl: hotelsXSellUrl(destination, startDate, isSameDay ? (0,addDays/* default */.Z)(endDate, 1) : endDate)
                };
            }
        case Product.Car:
            {
                var checkInDate1 = (0,parseISO/* default */.Z)(booking.utcCheckInDateTime);
                return {
                    product: "car",
                    xSellMessaging: "Your rental car booking unlocks VIP hotel deals of up to 40% off",
                    xSellTarget: "Hotels",
                    offerToken: booking.offerToken,
                    date: formattedDate,
                    headline: "".concat(booking.destinationCity),
                    subHeadline: "Pickup on ".concat((0,format/* default */.Z)(checkInDate1, "EEE, MMM do")),
                    xSellUrl: hotelsXSellUrl(booking.destinationCity, startDate, endDate)
                };
            }
    }
}
function buildRCInventoryRequest(param) {
    var pickupDateTime = param.pickupDateTime, returnDateTime = param.returnDateTime, pickupLocation = param.pickupLocation, returnLocation = param.returnLocation, offerToken = param.offerToken, tokenType = param.tokenType;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, serviceOptions), {
        data: {
            query: '{\n        rcXsell(\n          pickupDateTime: "'.concat(pickupDateTime, '",\n          returnDateTime: "').concat(returnDateTime, '",\n          pickupLocation: "').concat(pickupLocation, '",\n          returnLocation: "').concat(returnLocation, '",\n          offerToken: "').concat(offerToken, '",\n          tokenType: "').concat(tokenType, '"\n        ) {\n          listings: content {\n            id\n            checkoutUrl\n            carExample\n            isCarExampleExact\n            pricing {\n              price\n              currencySymbol\n              disclaimer\n              priceDescription\n            }\n            partner {\n              name\n              url\n            }\n            options\n            bannerType\n            carImageUrl\n            vehicleFeatures {\n              bagCapacity\n              isAirConditioned\n              isUnlimitedMileage\n              mileageDistance\n              mileageUnit\n              peopleCapacity\n            }\n            rate {\n              currencyCode\n              currencySymbol\n              dailyPrice\n              isFreeCancellation\n              isPrepay\n              savingsPriceTotal\n              strikeThroughPrice\n              totalPrice\n            }\n          }\n        }\n      }')
        }
    });
}
function buildHotelInventoryRequest(param) {
    var cityId = param.cityId, cityName = param.cityName, checkIn = param.checkIn, checkOut = param.checkOut, cguid = param.cguid, appc = param.appc, rid = param.rid, productId = param.productId, _pageSize = param.pageSize, pageSize = _pageSize === void 0 ? 3 : _pageSize, dealTypes = param.dealTypes;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, serviceOptions), {
        data: {
            variables: {
                cityId: cityId,
                cityName: cityName,
                checkIn: checkIn,
                checkOut: checkOut,
                cguid: cguid,
                appc: appc,
                rid: rid,
                productId: productId,
                pageSize: pageSize,
                dealTypes: dealTypes
            },
            query: "{\n        integratedListings(\n          cityId: ".concat(cityId, '\n          cityName: "').concat(cityName, '"\n          checkIn: ').concat(checkIn, "\n          checkOut: ").concat(checkOut, '\n          appc: "').concat(appc, '"\n          cguid: "').concat(cguid, '"\n          rid: "').concat(rid, '"\n          productId: ').concat(productId, "\n          pageSize: ").concat(pageSize, "\n        ) {\n          listings {\n            name\n            location\n            imageUrl\n            guestRating\n            guestReviewCount\n            starRating\n            savingPercentage\n            originalPrice\n            currentPrice\n            currency\n            currencySymbol\n            hotelId\n            href\n          }\n        }\n      }")
        }
    });
}
function buildItineraryDetailsRequest(offerToken, tokenType) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, serviceOptions), {
        data: {
            query: '{\n        itineraryDetails(offerToken: "'.concat(offerToken, '", tokenType: "').concat(tokenType, '") {\n          hotelXsellCarousel {\n            checkIn\n            checkOut\n            cityId\n            cityName\n          }\n          rcXsellRequestParams {\n            pickupDateTime\n            returnDateTime\n            pickupLocation\n            returnLocation\n          }\n        }\n      }')
        }
    });
}
function trackCrossSellClicks() {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Feature Box CTA",
        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
        label: "Cross Sell Choose Button"
    });
}
/**
 * This is needed because of the following scenarios
 *
 * view more button with inventory - example text is "view more rental car deals" - product is singular and lowercase
 * search button with no inventory - example text is "Search Rental Cars" - product is upper case and plural
 */ var X_SELL_PRODUCTS = {
    "Rental Cars": "rental car",
    Hotels: "hotel",
    Flights: "flight"
};
var trackViewTripClick = function() {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Feature Box Link",
        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
        label: "Cross Sell View Trip"
    });
};
var getProductIconFilled = function(product) {
    switch(product){
        case "flight":
        case "Flights":
            return FlightsFill/* default */.Z;
        case "car":
        case "Rental Cars":
            return CarsFill/* default */.Z;
        default:
            return HotelsFill/* default */.Z;
    }
};
var getProductIcon = function(product) {
    switch(product){
        case "flight":
        case "Flights":
            return Flights;
        case "car":
        case "Rental Cars":
            return Cars;
        default:
            return Hotels;
    }
};

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(37138);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Stamp/Stamp.js
var Stamp = __webpack_require__(57397);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/BlockLink/BlockLink.js
var BlockLink = __webpack_require__(21477);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Guests.js
var Guests = __webpack_require__(21404);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Luggage.js
var Luggage = __webpack_require__(26884);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Ac.js
var Ac = __webpack_require__(37516);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/FreeCancellation.js
var FreeCancellation = __webpack_require__(41269);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Mileage.js
var Mileage = __webpack_require__(6789);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
;// CONCATENATED MODULE: ./src/components/CrossSell/Common.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 185px;\n  width: 273px;\n  flex: 1 0;\n  background-color: ",
        ";\n  margin-right: 12px;\n  ",
        " {\n    margin-right: 15px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid rgba(89, 107, 125, 0.5);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0;\n  width: 100px;\n  background-image: url(",
        ");\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 19px;\n  hyphens: auto;\n  display: -webkit-box;\n  -moz-box-orient: vertical;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.6em;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n  top: -0.5em;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ProductWrapper = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-49e058f2-0"
})(_templateObject(), (0,utils/* getPaletteColor */.ow)("background.lightest"), function(props) {
    return props.theme.mediaQueries[0];
});
var ProductFlexBorder = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-49e058f2-1"
})(_templateObject1());
var ProductImage = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-49e058f2-2"
})(_templateObject2(), function(props) {
    return props.bgImage;
});
var ProductTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-49e058f2-3"
})(_templateObject3());
var PrimaryText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-49e058f2-4"
})(_templateObject4());
var SecondaryText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-49e058f2-5"
})(_templateObject5());
var StyledSup = styled_components_browser_esm/* default.sup.withConfig */.ZP.sup.withConfig({
    componentId: "sc-49e058f2-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/components/CrossSell/CarProduct.tsx

function CarProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  background-repeat: no-repeat;\n  background-size: contain;\n"
    ]);
    CarProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CarProduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n"
    ]);
    CarProduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CarProduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 35px;\n  font-size: 12px;\n"
    ]);
    CarProduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CarProduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  min-height: 20px;\n  width: fit-content;\n  font-size: 10px;\n"
    ]);
    CarProduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var CarImage = (0,styled_components_browser_esm/* default */.ZP)(ProductImage).withConfig({
    componentId: "sc-687492e7-0"
})(CarProduct_templateObject(), function(props) {
    return props.height;
});
var SmallText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-687492e7-1"
})(CarProduct_templateObject1());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-687492e7-2"
})(CarProduct_templateObject2());
var StyledStamp = (0,styled_components_browser_esm/* default */.ZP)(Stamp/* default */.Z).withConfig({
    componentId: "sc-687492e7-3"
})(CarProduct_templateObject3());
function CarProduct(param) {
    var carExample = param.carExample, carImageUrl = param.carImageUrl, checkoutUrl = param.checkoutUrl, offerId = param.offerId, rudderParentProductCode = param.rudderParentProductCode, url = param.partner.url, position = param.position, priceDescription = param.pricing.priceDescription, _rate = param.rate, currencySymbol = _rate.currencySymbol, dailyPrice = _rate.dailyPrice, isFreeCancellation = _rate.isFreeCancellation, savingsPriceTotal = _rate.savingsPriceTotal, totalPrice = _rate.totalPrice, _vehicleFeatures = param.vehicleFeatures, bagCapacity = _vehicleFeatures.bagCapacity, isAirConditioned = _vehicleFeatures.isAirConditioned, isUnlimitedMileage = _vehicleFeatures.isUnlimitedMileage, peopleCapacity = _vehicleFeatures.peopleCapacity;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), webstats = ref.webstats, customer = ref.customer;
    var vehicleFeature = function(Icon, text, isBold) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    size: 14,
                    mr: 1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallText, {
                    fontWeight: isBold ? "bold" : undefined,
                    children: text
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductWrapper, {
        "data-event-type": "cross-sell",
        "data-rudder-event": true,
        "data-child-product": "car",
        "data-position": position,
        "data-has-inventory": true,
        "data-label": "Choose",
        "data-parent-product": rudderParentProductCode,
        "data-source": "homepage",
        "data-sub-type": "cross sell",
        "data-cguid": webstats.clientGUID,
        "data-email-address": customer.emailAddress,
        "data-parent-offer-id": offerId,
        className: "cross-sell-unit",
        borderRadius: "xl",
        borderWidth: 0,
        boxShadowSize: "sm",
        m: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductFlexBorder, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        ml: 2,
                        my: "5px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarImage, {
                                height: "58px",
                                borderRadius: "xl",
                                rounded: "topLeft",
                                bgImage: carImageUrl
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                children: [
                                    vehicleFeature(Guests/* default */.Z, peopleCapacity, false),
                                    vehicleFeature(Luggage/* default */.Z, bagCapacity, false),
                                    isAirConditioned ? vehicleFeature(Ac/* default */.Z, "AC", false) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        width: "172px",
                        px: 2,
                        py: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTitle, {
                                children: "Economy Car"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallText, {
                                color: "text.light",
                                mb: 1,
                                children: carExample
                            }),
                            isFreeCancellation ? vehicleFeature(FreeCancellation/* default */.Z, "Free Cancellation", true) : null,
                            isUnlimitedMileage ? vehicleFeature(Mileage/* default */.Z, "Unlimited Mileage", true) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                px: 3,
                py: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStamp, {
                                        borderRadius: 2,
                                        bg: "alert",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                            color: "text.lightest",
                                            children: "PAY NOW & SAVE"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallText, {
                                        style: {
                                            width: "fit-content"
                                        },
                                        mt: 1,
                                        children: [
                                            "Save",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    currencySymbol,
                                                    savingsPriceTotal
                                                ]
                                            }),
                                            " ",
                                            "by paying now"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "baseline",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontSize: 4,
                                        color: "secondary",
                                        fontWeight: "light",
                                        children: "+"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                        fontSize: 4,
                                        color: "secondary",
                                        fontWeight: "bold",
                                        mr: 1,
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSup, {
                                                children: currencySymbol
                                            }),
                                            dailyPrice
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryText, {
                                        color: "secondary",
                                        children: priceDescription
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarImage, {
                                height: "35px",
                                bgImage: url
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                alignItems: "flex-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryText, {
                                        color: "text.light",
                                        children: [
                                            "Total: ",
                                            currencySymbol,
                                            totalPrice
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLink/* default */.Z, {
                                        onClick: trackCrossSellClicks,
                                        href: checkoutUrl,
                                        target: "_new",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                            color: "secondary",
                                            children: "Choose"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@pcln/vip/dist/esm/svgr/logos/LogoPricelineVip.js
var LogoPricelineVip = __webpack_require__(41188);
;// CONCATENATED MODULE: ./src/components/CrossSell/PricelineLogo.tsx


var PricelineLogo = function(param) {
    var _width = param.width, width = _width === void 0 ? "56px" : _width, _height = param.height, height = _height === void 0 ? "14px" : _height, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#007AFF" : _fillColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 56 14",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "priceline_blue"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    id: "priceline_blue",
                    fill: fillColor,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        id: "Group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M4.1836476,3.12794981 C6.07565478,3.12794981 7.539747,4.5573853 7.539747,7.12419247 C7.539747,8.70170512 6.84377035,11.1523413 4.19758353,11.1523413 C3.34093383,11.1523413 2.89723847,10.87214 2.29020584,10.5029697 L2.29020584,13.6745617 L-5.68434189e-14,13.6745617 L-5.68434189e-14,3.33288533 L2.02562814,3.33288533 L2.02562814,4.05568187 C2.0989967,3.96712191 2.17277515,3.878971 2.24634865,3.80513695 C2.63102126,3.43535309 3.32556332,3.12794981 4.1836476,3.12794981 Z M51.853892,3.05597764 C52.3108005,3.05597764 53.6393938,3.09954365 54.6288849,4.16588334 C55.630443,5.24784104 55.6897552,6.75970481 55.7185932,7.63328546 L50.2170798,7.63328546 C50.2005133,8.59790264 50.7472081,9.56149231 51.9714938,9.56149231 C53.2107097,9.56149231 53.6393938,8.74524616 53.9187747,8.19738306 L55.630443,9.07116922 C55.3655834,9.47168879 55.0997011,9.85720686 54.7014912,10.2285454 C54.0380127,10.8507995 53.0346139,11.3250936 51.7945798,11.3250936 C49.5079922,11.3250936 47.8996089,9.85720686 47.8996089,7.32195291 C47.8996089,5.45498507 48.8140394,3.05597764 51.853892,3.05597764 Z M27.6735156,3.05597764 C28.1320255,3.05597764 29.4623991,3.09954365 30.4515465,4.16588334 C31.4527492,5.24784104 31.5120041,6.75970481 31.5426531,7.63328546 L26.0378773,7.63328546 C26.0231657,8.59790264 26.568719,9.56149231 27.7916166,9.56149231 C29.0341296,9.56149231 29.4623991,8.74524616 29.7435532,8.19738306 L31.4527492,9.07116922 C31.1881456,9.47168879 30.9229291,9.85720686 30.5249,10.2285454 C29.8616543,10.8507995 28.855752,11.3250936 27.615078,11.3250936 C25.3304969,11.3250936 23.7236688,9.85720686 23.7236688,7.32195291 C23.7236688,5.45498507 24.6378281,3.05597764 27.6735156,3.05597764 Z M21.0399034,3.14585934 C21.708428,3.14585934 22.7457797,3.29249573 23.6337954,4.11878666 C23.1455816,4.599713 22.8266016,5.20533155 22.6417779,5.83761126 C22.6366496,5.85770967 22.6001361,5.84663503 22.5861871,5.82161456 C22.4668004,5.58945737 22.3123361,5.36529852 22.0013563,5.14154985 C21.7789934,4.99368294 21.4975525,4.87555349 21.1432898,4.87555349 C19.9153707,4.87555349 19.500389,6.28059672 19.500389,7.21168652 C19.500389,8.23321919 20.0041928,9.51951771 21.2177527,9.51951771 C21.3350881,9.51951771 21.8983801,9.51951771 22.3722346,8.98711481 C22.4493642,8.89872281 22.5061857,8.81730372 22.551725,8.73629481 C22.5675201,8.7116845 22.6040336,8.70430141 22.6103927,8.72501508 C22.7984986,9.38087967 23.1273249,9.92394702 23.5667173,10.344168 C23.4616898,10.4403532 23.3462006,10.5365385 23.2149162,10.6294424 C22.6222903,11.044126 21.8682257,11.3250936 20.9958001,11.3250936 C19.5165944,11.3250936 17.1629118,10.4376871 17.1629118,7.2859276 C17.1629118,5.03736623 18.4650887,3.14585934 21.0399034,3.14585934 Z M44.6168467,3.14585934 C45.0743009,3.14585934 45.5878907,3.23279677 45.9867597,3.45125492 C46.7963373,3.87580949 47.0008751,4.5630002 47.0008751,5.74709202 L47.0008751,10.9655668 L44.749735,10.9655668 L44.749735,6.66793974 C44.749735,5.97993842 44.7342211,5.73270378 44.6462413,5.52741796 C44.4686486,5.1186702 44.0712085,4.94256618 43.6298805,4.94256618 C42.4884239,4.94256618 42.4387953,5.81178032 42.4366376,6.72002785 L42.4365395,10.9655668 L40.1704979,10.9655668 L40.1704979,3.34972659 L42.453074,3.34972659 L42.453074,4.0211105 C42.6733297,3.7870482 42.8205071,3.61216009 43.2179472,3.42207312 C43.5714995,3.27697476 44.0712085,3.14585934 44.6168467,3.14585934 Z M38.552777,3.32562273 L38.552777,10.9655668 L36.3059424,10.9655668 L36.3059424,3.32562273 L38.552777,3.32562273 Z M34.8679683,2.66453526e-15 L34.8679683,10.9655668 L32.5312603,10.9655668 L32.5312603,2.66453526e-15 L34.8679683,2.66453526e-15 Z M16.1743046,3.32562273 L16.1743046,10.9655668 L13.92747,10.9655668 L13.92747,3.32562273 L16.1743046,3.32562273 Z M12.9388628,3.23574104 L12.9388628,5.22548665 L12.1915803,5.34260215 C11.110302,5.53400581 10.7870541,5.69516648 10.7870541,6.66111562 L10.7870541,10.9655668 L8.53506701,10.9655668 L8.53506701,3.30840542 L10.7288533,3.30840542 L10.7288533,4.11278794 C11.2262981,3.68816815 11.768154,3.35184167 12.9388628,3.23574104 Z M3.82869131,4.73409616 C3.41368757,4.73409616 2.98536272,4.91162514 2.66053263,5.35422042 C2.3344729,5.78147621 2.18794072,6.44618723 2.18794072,7.16816566 C2.18794072,8.14171165 2.43960718,8.74710999 2.73410614,9.07128444 C3.00032335,9.35189476 3.38499596,9.51387972 3.75491287,9.51387972 C4.86281916,9.51387972 5.35098652,8.31903609 5.35098652,7.10885298 C5.35098652,6.09235644 5.07062844,5.01572911 4.13876571,4.77827388 C4.03527095,4.7498447 3.93198113,4.73409616 3.82869131,4.73409616 Z M51.8397798,4.68435994 C51.293494,4.68435994 50.9100099,4.95130448 50.6872824,5.18783503 C50.3790634,5.52917059 50.3050254,5.88489115 50.2318056,6.21081421 L53.3739206,6.21081421 C53.3303568,5.88489115 53.2698174,5.45498507 52.9460546,5.11467701 C52.6650375,4.83273096 52.2377851,4.68435994 51.8397798,4.68435994 Z M27.6592127,4.68435994 C27.1128421,4.68435994 26.7307504,4.95130448 26.5102815,5.18783503 C26.200726,5.52917059 26.1267596,5.88489115 26.0534061,6.21081421 L29.1963653,6.21081421 C29.1522306,5.88489115 29.0931801,5.45498507 28.7672784,5.11467701 C28.4869417,4.83273096 28.0580591,4.68435994 27.6592127,4.68435994 Z M37.5196399,0.179763391 C38.1889224,0.179763391 38.7325238,0.72309937 38.7325238,1.3933697 C38.7325238,2.06302977 38.1889224,2.60656917 37.5196399,2.60656917 C36.8493405,2.60656917 36.3059424,2.06302977 36.3059424,1.3933697 C36.3059424,0.72309937 36.8493405,0.179763391 37.5196399,0.179763391 Z M15.0498701,0.179763391 C15.7205977,0.179763391 16.264178,0.72309937 16.264178,1.3933697 C16.264178,2.06302977 15.7205977,2.60656917 15.0498701,2.60656917 C14.3801597,2.60656917 13.8375966,2.06302977 13.8375966,1.3933697 C13.8375966,0.72309937 14.3801597,0.179763391 15.0498701,0.179763391 Z",
                                fillRule: "nonzero"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M84.5 2a2.5 2.5 0 0 1 2.2 1.2c.2.4.3.8.3 1.3 0 .4-.1.9-.3 1.2a2.5 2.5 0 0 1-4.4 0c-.2-.3-.3-.7-.3-1.2 0-.4.1-.9.3-1.2A2.5 2.5 0 0 1 84.5 2zm0 4.4c.3 0 .7-.1 1-.3a2 2 0 0 0 .9-1.6 1.8 1.8 0 0 0-1-1.6c-.2-.2-.5-.3-.9-.3a1.8 1.8 0 0 0-1.6 1c-.2.2-.3.6-.3 1a1.9 1.9 0 0 0 1.9 1.8zm1-2.3v.4c-.1.2-.2.3-.4.3l.5.8H85l-.3-.7H84v.7h-.5V3.3h1c.3 0 .5 0 .7.2.2.1.3.3.3.6zm-1.4.4h.5l.3-.1V4v-.3H84v.7z"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var CrossSell_PricelineLogo = (PricelineLogo);

;// CONCATENATED MODULE: ./src/components/CrossSell/HotelProduct.tsx

function HotelProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 102px;\n"
    ]);
    HotelProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HotelProduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 2px;\n"
    ]);
    HotelProduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HotelProduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"
    ]);
    HotelProduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HotelProduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  height: 24px;\n  line-height: 1;\n"
    ]);
    HotelProduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var HotelImage = (0,styled_components_browser_esm/* default */.ZP)(ProductImage).withConfig({
    componentId: "sc-10388aa2-0"
})(HotelProduct_templateObject());
var FeatureBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-10388aa2-1"
})(HotelProduct_templateObject1());
var LocationText = (0,styled_components_browser_esm/* default */.ZP)(SecondaryText).withConfig({
    componentId: "sc-10388aa2-2"
})(HotelProduct_templateObject2());
var StyledLogoPricelineVip = (0,styled_components_browser_esm/* default */.ZP)(LogoPricelineVip/* default */.Z).withConfig({
    componentId: "sc-10388aa2-3"
})(HotelProduct_templateObject3());
function HotelProduct(param) {
    var currencySymbol = param.currencySymbol, currentPrice = param.currentPrice, guestRating = param.guestRating, href = param.href, imageUrl = param.imageUrl, location = param.location, name = param.name, offerId = param.offerId, originalPrice = param.originalPrice, position = param.position, savingPercentage = param.savingPercentage, starRating = param.starRating, offerToken = param.offerToken, rudderParentProductCode = param.rudderParentProductCode;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), webstats = ref.webstats, customer = ref.customer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductWrapper, {
        "data-rudder-event": true,
        "data-child-product": "hotel",
        "data-position": position,
        "data-has-inventory": true,
        "data-label": "Choose",
        "data-parent-product": rudderParentProductCode,
        "data-source": "homepage",
        "data-sub-type": "cross sell",
        "data-cguid": webstats.clientGUID,
        "data-email-address": customer.emailAddress,
        "data-parent-offer-id": offerId,
        className: "cross-sell-unit",
        borderRadius: "xl",
        borderWidth: 0,
        boxShadowSize: "sm",
        m: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductFlexBorder, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelImage, {
                        borderRadius: "xl",
                        rounded: "topLeft",
                        bgImage: imageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        width: "172px",
                        px: 3,
                        py: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTitle, {
                                mb: "6px",
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationText, {
                                fontWeight: "bold",
                                color: "text.light",
                                mb: 2,
                                children: location
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureBox, {
                                        mr: 2,
                                        color: "alert",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryText, {
                                            color: "text.lightest",
                                            px: "6px",
                                            fontWeight: "bold",
                                            children: guestRating
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryText, {
                                        fontWeight: "bold",
                                        children: [
                                            starRating,
                                            "-Star Hotel"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                py: 2,
                flexDirection: "column",
                mb: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        px: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSell_PricelineLogo, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogoPricelineVip, {
                                px: 2,
                                variation: "vip"
                            }),
                            savingPercentage && savingPercentage > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PrimaryText, {
                                color: "primary.dark",
                                px: "6px",
                                fontWeight: "bold",
                                children: [
                                    savingPercentage,
                                    "% off"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexDirection: "column",
                                px: 3,
                                children: [
                                    originalPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryText, {
                                        fontWeight: "bold",
                                        children: [
                                            "was ",
                                            currencySymbol,
                                            originalPrice
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "baseline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                                fontSize: 3,
                                                fontWeight: "bold",
                                                mr: 1,
                                                color: "primary.dark",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSup, {
                                                        children: currencySymbol
                                                    }),
                                                    currentPrice
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryText, {
                                                color: "text.light",
                                                fontSize: 0,
                                                children: "per night"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLink/* default */.Z, {
                                onClick: trackCrossSellClicks,
                                href: "".concat(href, "&xsellToken=").concat(offerToken),
                                target: "_new",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                    color: "secondary",
                                    mx: 1,
                                    children: "Choose"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/inventoryHelper.tsx








function fireEventForViewMoreDeals() {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Feature Box CTA",
        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
        label: "Cross Sell View More Deals"
    });
}
function isCarListing(listing) {
    return listing.carExample !== undefined;
}
function renderXSellProduct(listing, position, offerId, offerToken, rudderParentProductCode) {
    if (isCarListing(listing)) {
        return /*#__PURE__*/ (0,react.createElement)(CarProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, listing), {
            key: listing.id,
            offerId: offerId,
            position: position,
            rudderParentProductCode: rudderParentProductCode
        }));
    }
    return /*#__PURE__*/ (0,react.createElement)(HotelProduct, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, listing), {
        key: listing.hotelId,
        offerId: offerId,
        position: position,
        offerToken: offerToken,
        rudderParentProductCode: rudderParentProductCode
    }));
}
function renderXSellProducts(listings) {
    var numProducts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, offerId = arguments.length > 2 ? arguments[2] : void 0, offerToken = arguments.length > 3 ? arguments[3] : void 0, rudderParentProductCode = arguments.length > 4 ? arguments[4] : void 0;
    return listings.slice(0, numProducts).map(function(listing, index) {
        return renderXSellProduct(listing, index + 1, offerId, offerToken, rudderParentProductCode);
    });
}

// EXTERNAL MODULE: ./src/utils/rudder-stack.ts
var rudder_stack = __webpack_require__(964);
;// CONCATENATED MODULE: ./src/components/CrossSell/InventoryHeading.tsx



var Heading = function(param) {
    var xSellMessaging = param.xSellMessaging;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        color: "text.heading",
        textStyle: [
            "heading4",
            null,
            null,
            "heading5"
        ],
        children: xSellMessaging
    });
};
var HeadingNonXL = function(param) {
    var xSellMessaging = param.xSellMessaging, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "baseline",
        ml: [
            3,
            null,
            null,
            0
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                xSellMessaging: xSellMessaging
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 3,
                children: children
            })
        ]
    });
};
var HeadingXL = function(param) {
    var xSellMessaging = param.xSellMessaging, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "space-between",
        alignItems: "baseline",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                xSellMessaging: xSellMessaging
            }),
            children
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/CrossSell/Inventory.tsx

function Inventory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: bold;\n"
    ]);
    Inventory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Inventory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto hidden;\n  & > :last-child {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    Inventory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var ViewMoreDeals = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-3fc9c2d4-0"
})(Inventory_templateObject());
var ScrollContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3fc9c2d4-1"
})(Inventory_templateObject1(), (0,index_esm/* themeGet */.R)("space.1"));
function Inventory(param) {
    var xSellMessaging = param.xSellMessaging, xSellProduct = param.xSellProduct, rudderChildProductCode = param.rudderChildProductCode, rudderParentProductCode = param.rudderParentProductCode, xSellUrl = param.xSellUrl, listings = param.listings, offerId = param.offerId, offerToken = param.offerToken;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, webstats = ref.webstats, customer = ref.customer;
    (0,react.useEffect)(function() {
        (0,rudder_stack/* default */.Z)({
            label: "View more ".concat(xSellProduct, " deals"),
            parentProduct: rudderParentProductCode,
            childProduct: rudderChildProductCode,
            source: "homepage",
            subType: "cross sell",
            hasInventory: false,
            cguid: webstats.clientGUID,
            emailAddress: customer.emailAddress,
            parentOfferId: offerId,
            rudderEvent: true,
            category: "impression"
        });
    }, [
        xSellProduct,
        rudderParentProductCode,
        rudderChildProductCode,
        webstats.clientGUID,
        customer.emailAddress,
        offerId
    ]);
    var viewMoreDeals = function() {
        var target = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).target;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewMoreDeals, {
            "data-cguid": webstats.clientGUID,
            "data-email-address": customer.emailAddress,
            "data-parent-offer-id": offerId,
            "data-label": "View more ".concat(xSellProduct, " deals"),
            "data-child-product": rudderChildProductCode,
            "data-parent-product": rudderParentProductCode,
            "data-has-inventory": listings.length > 1,
            "data-source": "homepage",
            "data-sub-type": "cross sell",
            "data-rudder-event": true,
            "data-view-more": true,
            onClick: fireEventForViewMoreDeals,
            href: xSellUrl,
            target: target,
            color: "primary",
            variation: "fill",
            py: 2,
            px: 3,
            children: [
                "View more ",
                xSellProduct,
                " deals"
            ]
        });
    };
    var renderedProducts = renderXSellProducts(listings, isMobile ? 2 : 3, offerId, offerToken, rudderParentProductCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hide/* default */.Z, {
                width: 8 / 11,
                mt: 40,
                ml: 24,
                xs: true,
                sm: true,
                md: true,
                lg: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingXL, {
                        xSellMessaging: xSellMessaging,
                        children: viewMoreDeals({
                            target: "_blank"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollContainer, {
                        "data-testid": "inventory-list",
                        mt: 12,
                        children: renderedProducts
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hide/* default */.Z, {
                width: [
                    1,
                    null,
                    2 / 3
                ],
                mt: [
                    24,
                    null,
                    3,
                    40
                ],
                ml: [
                    0,
                    null,
                    null,
                    24
                ],
                mb: [
                    0,
                    null,
                    null,
                    24
                ],
                xl: true,
                xxl: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingNonXL, {
                        xSellMessaging: xSellMessaging,
                        children: viewMoreDeals({
                            target: "_blank"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollContainer, {
                        mx: [
                            -3,
                            null,
                            null,
                            0
                        ],
                        px: [
                            3,
                            null,
                            null,
                            0
                        ],
                        mt: 24,
                        children: renderedProducts
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/NoInventoryFallback.tsx

function NoInventoryFallback_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    NoInventoryFallback_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NoInventoryFallback_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    NoInventoryFallback_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var NoInventoryWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5c131fcf-0"
})(NoInventoryFallback_templateObject());
var InventoryTextWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5c131fcf-1"
})(NoInventoryFallback_templateObject1());
var TextSpan = Text/* default.span */.ZP.span;
function NoInventoryFallback(param) {
    var xSellMessaging = param.xSellMessaging, xSellTarget = param.xSellTarget, xSellUrl = param.xSellUrl, rudderChildProductCode = param.rudderChildProductCode, rudderParentProductCode = param.rudderParentProductCode, offerId = param.offerId, dataIsLoading = param.dataIsLoading;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), webstats = ref.webstats, customer = ref.customer;
    (0,react.useEffect)(function() {
        if (!dataIsLoading) {
            (0,rudder_stack/* default */.Z)({
                label: "Search ".concat(xSellTarget),
                parentProduct: rudderParentProductCode,
                childProduct: rudderChildProductCode,
                source: "homepage",
                subType: "cross sell",
                hasInventory: false,
                cguid: webstats.clientGUID,
                emailAddress: customer.emailAddress,
                parentOfferId: offerId,
                rudderEvent: true,
                category: "impression"
            });
        }
    }, [
        xSellTarget,
        rudderParentProductCode,
        rudderChildProductCode,
        webstats.clientGUID,
        customer.emailAddress,
        offerId,
        dataIsLoading
    ]);
    var ProductIcon = getProductIconFilled(xSellTarget || "hotel");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoInventoryWrapper, {
            "data-label": "Search ".concat(xSellTarget),
            "data-parent-product": rudderParentProductCode,
            "data-child-product": rudderChildProductCode,
            "data-source": "homepage",
            "data-sub-type": "cross sell",
            "data-has-inventory": false,
            "data-cguid": webstats.clientGUID,
            "data-email-address": customer.emailAddress,
            "data-parent-offer-id": offerId,
            "data-rudder-event": true,
            color: "background.lightest",
            borderRadius: "xl",
            py: 3,
            px: 24,
            width: [
                1,
                2 / 3,
                8 / 11
            ],
            "data-testid": "no-inventory-fallback",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                    xs: true,
                    sm: true,
                    md: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "full",
                        mr: 4,
                        width: "80px",
                        height: "80px",
                        bg: (0,utils/* getPaletteColor */.ow)("background.lightest"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIcon, {
                            size: "32px"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InventoryTextWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                                    xxl: true,
                                    xl: true,
                                    lg: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "full",
                                        mr: 2,
                                        width: "56px",
                                        height: "56px",
                                        bg: (0,utils/* getPaletteColor */.ow)("background.lightest"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIcon, {
                                            size: "32px"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            color: "highlight.light",
                                            mr: "auto",
                                            px: 2,
                                            py: 1,
                                            borderRadius: "lg",
                                            mb: 2,
                                            display: "table",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                color: "highlight.shade",
                                                fontSize: 12,
                                                bold: true,
                                                children: "SAVE UP TO 40%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                            color: "text.heading",
                                            textStyle: [
                                                "heading5",
                                                null,
                                                "heading3"
                                            ],
                                            mb: 3,
                                            children: xSellMessaging
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSpan, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                onClick: function() {
                                    analytics/* default.fireEvent */.Z.fireEvent({
                                        action: "Feature Box CTA",
                                        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                                        label: "Cross Sell Search Button"
                                    });
                                },
                                href: xSellUrl,
                                target: "_blank",
                                "data-testid": "XSELL_SEARCH_BUTTON",
                                variation: "fill",
                                children: [
                                    "Search ",
                                    xSellTarget
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/TripDetailsBox.tsx

function TripDetailsBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: bold;\n"
    ]);
    TripDetailsBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ViewTripLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-ab66ffbd-0"
})(TripDetailsBox_templateObject());
function TripDetailsBox(param) {
    var product = param.product, headline = param.headline, subHeadline = param.subHeadline;
    var ProductIcon = getProductIconFilled(product || "hotel");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "full",
                        mr: 2,
                        minWidth: "56px",
                        minHeight: "56px",
                        bg: (0,utils/* getPaletteColor */.ow)("priceSecondary.light"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIcon, {
                            color: "primary.dark",
                            size: "32px",
                            mr: 2
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        ml: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                color: "text",
                                textStyle: "heading4",
                                mb: 1,
                                children: headline
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                color: "text.base",
                                textStyle: "subheading6",
                                mt: 1,
                                children: subHeadline
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewTripLink, {
                href: "/next-profile/trips",
                onClick: trackViewTripClick,
                variation: "fill",
                mt: 3,
                mr: "auto",
                width: 1,
                children: "View Trip"
            })
        ]
    });
}
/* harmony default export */ var CrossSell_TripDetailsBox = (TripDetailsBox);

;// CONCATENATED MODULE: ./src/components/CrossSell/BookingInfo.tsx





function BookingInfo(param) {
    var product = param.product, date = param.date, headline = param.headline, subHeadline = param.subHeadline;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _customer = ref.customer, _firstName = _customer.firstName, firstName = _firstName === void 0 ? "" : _firstName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        pt: [
            "24px",
            4
        ],
        pb: [
            3,
            4
        ],
        px: [
            3,
            "24px"
        ],
        flexDirection: "column",
        justifyContent: "center",
        width: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                textStyle: [
                    "heading3",
                    null,
                    null,
                    null,
                    "heading2"
                ],
                mb: 2,
                color: "text.heading",
                className: firstName ? "fs-mask" : "",
                children: [
                    firstName ? "".concat(firstName, ", your") : "Your ",
                    " trip is coming up!"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                textStyle: "subheading5",
                color: "text.light",
                mb: "24px",
                children: date
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSell_TripDetailsBox, {
                product: product,
                headline: headline,
                subHeadline: subHeadline
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@pcln/request/dist/esm/index.js
var esm = __webpack_require__(37947);
var esm_default = /*#__PURE__*/__webpack_require__.n(esm);
;// CONCATENATED MODULE: ./src/components/CrossSell/useCrossSellInventory.ts









function getHotelItineraryDetails(offerToken) {
    return _getHotelItineraryDetails.apply(this, arguments);
}
function _getHotelItineraryDetails() {
    _getHotelItineraryDetails = (0,_async_to_generator/* default */.Z)(function(offerToken) {
        var itineraryResponse, _data, tmp, ref, _itineraryDetails, itineraryDetails, _hotelXsellCarousel;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        esm_default()(buildItineraryDetailsRequest(offerToken, "AES"))
                    ];
                case 1:
                    itineraryResponse = _state.sent();
                    _data = itineraryResponse.data, tmp = _data.data, ref = tmp === void 0 ? {} : tmp, _itineraryDetails = ref.itineraryDetails, itineraryDetails = _itineraryDetails === void 0 ? {} : _itineraryDetails;
                    return [
                        2,
                        (_hotelXsellCarousel = itineraryDetails.hotelXsellCarousel) !== null && _hotelXsellCarousel !== void 0 ? _hotelXsellCarousel : {}
                    ];
            }
        });
    });
    return _getHotelItineraryDetails.apply(this, arguments);
}
/**
 * Custom Hook to get XSell Inventory on client side, as it is done in a useEffect callback
 */ function useCrossSellInventory(booking) {
    var ref = (0,react.useState)({
        listings: [],
        offerId: booking.offerId || ""
    }), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(true), loading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref2.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, referral = ref2.referral, webstats = ref2.webstats;
    var cguid = webstats.clientGUID;
    (0,react.useEffect)(function() {
        function getXSell() {
            return _getXSell.apply(this, arguments);
        }
        function _getXSell() {
            _getXSell = (0,_async_to_generator/* default */.Z)(function() {
                var productType, pickupLocation, returnDateTime, pickupDateTime, offerToken, offerId, requestOptions, hotelItineraryDetails, _id, carInventoryParams, response, _data, _data1, integratedListings, rcXsell, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                6,
                                7
                            ]);
                            productType = booking.productId, pickupLocation = booking.destinationCity, returnDateTime = booking.travelEndDateTime, pickupDateTime = booking.travelStartDateTime, offerToken = booking.secureToken, offerId = booking.offerId;
                            if (!(productType !== Product.Hotel)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                getHotelItineraryDetails(offerToken)
                            ];
                        case 1:
                            hotelItineraryDetails = _state.sent();
                            requestOptions = buildHotelInventoryRequest((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hotelItineraryDetails), {
                                appc: isMobile ? "MOBILE" : "DESKTOP",
                                rid: (_id = referral.id) !== null && _id !== void 0 ? _id : "",
                                productId: productType,
                                pageSize: isMobile ? 2 : 3,
                                dealTypes: false,
                                cguid: cguid
                            }));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            carInventoryParams = {
                                pickupDateTime: pickupDateTime,
                                returnDateTime: returnDateTime,
                                pickupLocation: pickupLocation,
                                returnLocation: pickupLocation,
                                offerToken: offerToken,
                                tokenType: "AES"
                            };
                            requestOptions = buildRCInventoryRequest(carInventoryParams);
                            _state.label = 3;
                        case 3:
                            return [
                                4,
                                esm_default()(requestOptions)
                            ];
                        case 4:
                            response = _state.sent();
                            _data = response.data, _data1 = _data.data, integratedListings = _data1.integratedListings, rcXsell = _data1.rcXsell;
                            if (productType === Product.Hotel) {
                                setData((rcXsell === null || rcXsell === void 0 ? void 0 : rcXsell.listings) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rcXsell), {
                                    offerId: offerId
                                }) : {
                                    listings: [],
                                    offerId: offerId
                                });
                            } else {
                                setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, integratedListings), {
                                    offerId: offerId
                                }));
                            }
                            return [
                                3,
                                7
                            ];
                        case 5:
                            e = _state.sent();
                            // eslint-disable-next-line no-console
                            console.log("Failed to load inventory ");
                            return [
                                3,
                                7
                            ];
                        case 6:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return _getXSell.apply(this, arguments);
        }
        getXSell();
    }, [
        booking,
        cguid,
        isMobile,
        referral.id
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        loading: loading
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/useCrossSellAnalytics.ts



var useCrossSellAnalytics = function(listings) {
    (0,react.useEffect)(function() {
        analytics/* default.fireEvent */.Z.fireEvent({
            action: "xsell load",
            category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
            label: "xsell display"
        });
    }, []);
    (0,react.useEffect)(function() {
        if (listings.length > 1) {
            analytics/* default.fireEvent */.Z.fireEvent({
                action: "upcoming trip",
                category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                label: "xsell inventory display"
            });
        }
    }, [
        listings.length
    ]);
};
/* harmony default export */ var CrossSell_useCrossSellAnalytics = (useCrossSellAnalytics);

;// CONCATENATED MODULE: ./src/components/CrossSell/CrossSell.tsx

function CrossSell_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 4px solid ",
        ";\n"
    ]);
    CrossSell_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-81e0a8c5-0"
})(CrossSell_templateObject(), (0,utils/* getPaletteColor */.ow)("primary.base"));
function CrossSell(param) {
    var booking = param.booking;
    var ref = buildContent(booking), product = ref.product, date = ref.date, headline = ref.headline, offerToken = ref.offerToken, subHeadline = ref.subHeadline, xSellMessaging = ref.xSellMessaging, xSellTarget = ref.xSellTarget, xSellUrl = ref.xSellUrl;
    var xSellProduct = X_SELL_PRODUCTS[xSellTarget];
    var ref1 = useCrossSellInventory(booking), listings = ref1.listings, offerId = ref1.offerId, loading = ref1.loading;
    CrossSell_useCrossSellAnalytics(listings);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: "cross-sell-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HighlightedFlex/* HighlightedFlex */.z, {
            shadowOffsetX: 24,
            shadowOffsetY: 24,
            maxWidth: 1216,
            flexDirection: [
                "column",
                null,
                "row"
            ],
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                    width: [
                        1,
                        null,
                        1 / 3,
                        null,
                        3 / 11
                    ],
                    color: "background.lightest",
                    boxShadowSize: "md",
                    borderRadius: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingInfo, {
                        product: product,
                        date: date,
                        headline: headline,
                        subHeadline: subHeadline
                    })
                }),
                offerId && (listings.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Inventory, {
                    listings: listings,
                    offerId: offerId,
                    xSellMessaging: xSellMessaging,
                    xSellProduct: xSellProduct,
                    rudderParentProductCode: product,
                    rudderChildProductCode: xSellProduct,
                    xSellUrl: xSellUrl,
                    offerToken: offerToken
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoInventoryFallback, {
                    xSellMessaging: xSellMessaging,
                    xSellTarget: xSellTarget,
                    xSellUrl: xSellUrl,
                    rudderParentProductCode: product,
                    rudderChildProductCode: xSellProduct,
                    offerId: offerId,
                    dataIsLoading: loading
                }))
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/CrossSell/index.tsx



/***/ }),

/***/ 73345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form; }
});

// UNUSED EXPORTS: createOption

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Select/Select.js
var Select = __webpack_require__(16031);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/FormField/FormField.js
var FormField = __webpack_require__(23341);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Label/Label.js
var Label = __webpack_require__(98028);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Input/Input.js
var Input = __webpack_require__(84498);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Search.js
var Search = __webpack_require__(72148);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Cruises.js
var Cruises = __webpack_require__(3474);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Pin.js
var Pin = __webpack_require__(28387);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Calendar.js
var Calendar = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Clock.js
var Clock = __webpack_require__(21706);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/User.js
var User = __webpack_require__(16966);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
;// CONCATENATED MODULE: ./src/components/FindYourDealButton/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    transform: scale(",
        ");\n    box-shadow: ",
        ";\n    transition: 0.2s ease-in-out;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-9e781359-0"
})(_templateObject(), function(props) {
    return props.scale;
}, function(props) {
    return props.animatedBoxShadow;
});
function FindYourDealButton(param) {
    var _currentProduct = param.currentProduct, currentProduct = _currentProduct === void 0 ? "" : _currentProduct, formButtonProps = param.formButtonProps, hasMinWidth = param.hasMinWidth, isLargeInput = param.isLargeInput;
    var buttonText = "Find Your ".concat(currentProduct.charAt(0).toUpperCase()).concat(currentProduct.slice(1, -1));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        m: 0,
        width: 1,
        size: "large",
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        scale: theme/* theme.scale.scale-100 */.rS.scale["scale-100"] + theme/* theme.scale.scale-2 */.rS.scale["scale-2"],
        animatedBoxShadow: theme/* theme.shadows.xl */.rS.shadows.xl,
        style: {
            whiteSpace: "nowrap",
            minWidth: hasMinWidth ? "165px" : null,
            height: isLargeInput ? "56px" : null
        }
    }, formButtonProps), {
        children: buttonText
    }));
}
/* harmony default export */ var components_FindYourDealButton = (FindYourDealButton);

// EXTERNAL MODULE: ./src/constants/products.ts
var products = __webpack_require__(27204);
;// CONCATENATED MODULE: ./src/components/Cruises/constants.ts
var UNDER_FIFTY_FIVE_SELECT_UNCHOSEN_LABEL = "Under 55";
var UNDER_FIFTY_FIVE_SELECT_NO_LABEL = "No";
var UNDER_FIFTY_FIVE_SELECT_YES_LABEL = "YES";
var locationOptions = [
    {
        value: "",
        label: "Where are you going?",
        disabled: true,
        selected: true
    },
    {
        value: "C",
        label: "Caribbean"
    },
    {
        value: "M",
        label: "Mexico"
    },
    {
        value: "BH",
        label: "Bahamas"
    },
    {
        value: "A",
        label: "Alaska"
    },
    {
        value: "E",
        label: "Europe - All"
    },
    {
        value: "H",
        label: "Hawaii"
    },
    {
        value: "BM",
        label: "Bermuda"
    },
    {
        value: "NN",
        label: "Canada/New England/NY"
    },
    {
        value: "_",
        disabled: true,
        label: "-------------"
    },
    {
        value: "ALL",
        label: "All Destinations"
    },
    {
        value: "A",
        label: "Alaska - All"
    },
    {
        value: "AG",
        label: "Alaska - Gulf of Alaska"
    },
    {
        value: "AR",
        label: "Alaska - Inside Passage"
    },
    {
        value: "AB",
        label: "Antarctica"
    },
    {
        value: "UN",
        label: "Australia/New Zealand"
    },
    {
        value: "BH",
        label: "Bahamas"
    },
    {
        value: "BM",
        label: "Bermuda"
    },
    {
        value: "NN",
        label: "Canada/New England/NY"
    },
    {
        value: "C",
        label: "Caribbean - All"
    },
    {
        value: "CE",
        label: "Caribbean - Eastern"
    },
    {
        value: "CS",
        label: "Caribbean - Southern"
    },
    {
        value: "CW",
        label: "Caribbean - Western"
    },
    {
        value: "CN",
        label: "Cruise to Nowhere"
    },
    {
        value: "E",
        label: "Europe - All"
    },
    {
        value: "EE",
        label: "Europe - E. Mediterranean"
    },
    {
        value: "R",
        label: "Europe - Mediterranean - All"
    },
    {
        value: "N",
        label: "Europe - Northern"
    },
    {
        value: "EW",
        label: "Europe - W. Mediterranean"
    },
    {
        value: "W",
        label: "Europe - Western"
    },
    {
        value: "O",
        label: "Exotic - Asia/Africa/Other"
    },
    {
        value: "H",
        label: "Hawaii"
    },
    {
        value: "M",
        label: "Mexico"
    },
    {
        value: "T",
        label: "Panama Canal/C. America"
    },
    {
        value: "S",
        label: "South America"
    },
    {
        value: "I",
        label: "South Pacific - All"
    },
    {
        value: "TH",
        label: "South Pacific - Tahiti"
    },
    {
        value: "ET",
        label: "Transatlantic"
    },
    {
        value: "NA",
        label: "U.S. - All"
    },
    {
        value: "RV",
        label: "U.S. - American Rivers"
    },
    {
        value: "PC",
        label: "U.S. - Pacific/Northwest"
    },
    {
        value: "NC",
        label: "U.S. - Southeast"
    },
    {
        value: "WW",
        label: "World Cruise"
    }
];
var cruiseLineOptions = [
    {
        value: "",
        label: "Which cruise line?",
        disabled: true,
        selected: true
    },
    {
        value: "ALL",
        label: "All Cruise Lines"
    },
    {
        value: "92",
        label: "AmaWaterways"
    },
    {
        value: "329",
        label: "Avalon Waterways"
    },
    {
        value: "325",
        label: "Azamara Cruises"
    },
    {
        value: "1",
        label: "Carnival Cruise Lines"
    },
    {
        value: "11",
        label: "Celebrity Cruises"
    },
    {
        value: "14",
        label: "Costa Cruises"
    },
    {
        value: "17",
        label: "Crystal Cruises"
    },
    {
        value: "18",
        label: "Cunard"
    },
    {
        value: "20",
        label: "Disney Cruise Line"
    },
    {
        value: "24",
        label: "Holland America Line"
    },
    {
        value: "338",
        label: "Hurtigruten Cruises"
    },
    {
        value: "71",
        label: "MSC Cruises"
    },
    {
        value: "34",
        label: "Norwegian Cruise Line"
    },
    {
        value: "67",
        label: "Oceania Cruises"
    },
    {
        value: "344",
        label: "Ponant"
    },
    {
        value: "40",
        label: "Princess Cruises"
    },
    {
        value: "41",
        label: "Regent Seven Seas Cruises"
    },
    {
        value: "44",
        label: "Royal Caribbean"
    },
    {
        value: "50",
        label: "Silversea Cruises"
    },
    {
        value: "48",
        label: "The Yachts of Seabourn"
    },
    {
        value: "66",
        label: "Uniworld River Cruises"
    },
    {
        value: "78",
        label: "Viking River Cruises"
    },
    {
        value: "364",
        label: "Virgin Voyages"
    },
    {
        value: "64",
        label: "Windstar Cruises"
    }
];
var durationOptions = [
    {
        value: "",
        label: "Cruise length",
        disabled: true,
        selected: true
    },
    {
        value: "ALL",
        label: "All"
    },
    {
        value: "1",
        label: "1-2 Nights"
    },
    {
        value: "2",
        label: "3-5 Nights"
    },
    {
        value: "3",
        label: "6-8 Nights"
    },
    {
        value: "4",
        label: "9-11 Nights"
    },
    {
        value: "5",
        label: "12+ Nights"
    }
];

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
;// CONCATENATED MODULE: ./src/components/Cruises/SearchForm/utils.ts





var trackCruisesSubmit = function(values) {
    var data = [
        "Destination_".concat(values.location),
        "Cruise line_".concat(values.cruiseLine),
        "Zip Code_".concat(values.zip),
        "Departure Date ".concat(values.startDate),
        "Cruise Length_".concat(values.duration),
        "55 years or older_".concat(values.under55 ? "N" : "Y")
    ].join("|");
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Cruises Search Button",
        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
        data: data
    });
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Cruises Search",
        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
        data: "Valid"
    });
};
var handleSubmit = function(data, referral) {
    return function(e) {
        e.preventDefault();
        var location = data.location, cruiseLine = data.cruiseLine, zip = data.zip, startDate = data.startDate, duration = data.duration, under55 = data.under55;
        var query = "?".concat(query_string.stringify({
            places: location,
            operator: cruiseLine,
            Month: startDate,
            days: duration,
            shoppingZipCode: zip,
            IncludeSeniorRates: under55 === "true",
            sort_by: 7,
            refId: referral.id,
            refClickId: referral.clickId
        }));
        trackCruisesSubmit(data);
        window.open("//cruises.priceline.com/results.do".concat(query));
    };
};
var currentMonth = (0,format/* default */.Z)(new Date(), "MM/1/yyyy");
var createDateOptions = function(date) {
    var options = [];
    var parseOptions = function(i) {
        var newMonth = (0,add/* default */.Z)(date, {
            months: i
        });
        var monthDate = (0,format/* default */.Z)(newMonth, "MM/1/yyyy");
        options.push({
            value: monthDate,
            label: (0,format/* default */.Z)(newMonth, "MMMM yyyy")
        });
    };
    times_default()(24, parseOptions);
    return options;
};

;// CONCATENATED MODULE: ./src/components/Cruises/SearchForm/Form.tsx



function Form_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    Form_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-c73c3118-0"
})(Form_templateObject());
var createOption = function(option, i) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option), {
        children: option.label
    }), "".concat(option.label).concat(i));
};
var locations = locationOptions.map(createOption);
var cruiseLines = cruiseLineOptions.map(createOption);
var dateOptions = createDateOptions(new Date()).map(createOption);
var durations = durationOptions.map(createOption);
var CruisesSearchForm = function() {
    var ref = (0,react.useState)(""), location = ref[0], setLocation = ref[1];
    var ref1 = (0,react.useState)(""), cruiseLine = ref1[0], setCruiseLine = ref1[1];
    var ref2 = (0,react.useState)(""), zip = ref2[0], setZIP = ref2[1];
    var ref3 = (0,react.useState)(currentMonth), startDate = ref3[0], setStartDate = ref3[1];
    var ref4 = (0,react.useState)(""), duration = ref4[0], setDuration = ref4[1];
    var ref5 = (0,react.useState)(""), under55 = ref5[0], setUnder55 = ref5[1];
    var ref6 = (0,react.useContext)(BootstrapDataContext/* default */.Z), _referral = ref6.referral, referral = _referral === void 0 ? {} : _referral;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                onSubmit: handleSubmit({
                    location: location,
                    cruiseLine: cruiseLine,
                    zip: zip,
                    startDate: startDate,
                    duration: duration,
                    under55: under55
                }, referral),
                id: "cruise-form",
                "aria-label": "cruise-search-form",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexWrap: "wrap",
                    mx: -2,
                    width: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: [
                                1,
                                1 / 2,
                                null,
                                null,
                                2 / 5
                            ],
                            px: 2,
                            mb: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        autoHide: location === "",
                                        htmlFor: "location",
                                        children: "Where are you going?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                        id: "location",
                                        name: "location",
                                        value: location,
                                        onChange: function(e) {
                                            setLocation(e.target.value);
                                        },
                                        children: locations
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: [
                                1,
                                1 / 2,
                                null,
                                null,
                                2 / 5
                            ],
                            px: 2,
                            mb: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        autoHide: cruiseLine === "",
                                        htmlFor: "cruiseLine",
                                        children: "Which cruise line?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cruises/* default */.Z, {
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                        id: "cruiseLine",
                                        name: "cruiseLine",
                                        value: cruiseLine,
                                        onChange: function(e) {
                                            setCruiseLine(e.target.value);
                                        },
                                        children: cruiseLines
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: [
                                1,
                                1 / 2,
                                null,
                                null,
                                1 / 5
                            ],
                            px: 2,
                            mb: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        autoHide: zip === "",
                                        htmlForm: "zip",
                                        children: "ZIP code"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pin/* default */.Z, {
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "zip",
                                        name: "zip",
                                        value: zip,
                                        placeholder: "ZIP code",
                                        minLength: "5",
                                        maxLength: "5",
                                        onChange: function(e) {
                                            setZIP(e.target.value);
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: [
                                1,
                                1 / 2,
                                null,
                                null,
                                1 / 4
                            ],
                            px: 2,
                            mb: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        autoHide: true,
                                        htmlFor: "startDate",
                                        children: "Departing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar/* default */.Z, {
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                        id: "startDate",
                                        name: "startDate",
                                        value: startDate,
                                        onChange: function(e) {
                                            setStartDate(e.target.value);
                                        },
                                        children: dateOptions
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: [
                                1,
                                1 / 2,
                                null,
                                null,
                                1 / 4
                            ],
                            px: 2,
                            mb: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        autoHide: duration === "",
                                        htmlFor: "duration",
                                        children: "Cruise length"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Clock/* default */.Z, {
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                        id: "duration",
                                        name: "duration",
                                        value: duration,
                                        onChange: function(e) {
                                            setDuration(e.target.value);
                                        },
                                        children: durations
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: [
                                1,
                                1 / 2,
                                null,
                                null,
                                1 / 4
                            ],
                            px: 2,
                            mb: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        autoHide: under55 === "",
                                        htmlFor: "underFiftyFive",
                                        children: "Under 55"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(User/* default */.Z, {
                                        color: "primary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelect, {
                                        id: "underFiftyFive",
                                        name: "underFiftyFive",
                                        value: under55,
                                        onChange: function(e) {
                                            setUnder55(e.target.value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                disabled: true,
                                                value: "",
                                                label: "Under 55",
                                                defaultValue: "",
                                                children: UNDER_FIFTY_FIVE_SELECT_UNCHOSEN_LABEL
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "false",
                                                label: "No",
                                                children: UNDER_FIFTY_FIVE_SELECT_NO_LABEL
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "true",
                                                label: "Yes",
                                                children: UNDER_FIFTY_FIVE_SELECT_YES_LABEL
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: [
                                1,
                                null,
                                null,
                                null,
                                1 / 4
                            ],
                            px: 2,
                            ml: "auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FindYourDealButton, {
                                currentProduct: products/* CRUISE_PRODUCT_TYPE */.ZE
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Form = (CruisesSearchForm);


/***/ }),

/***/ 38292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ExtendStay; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Badge/Badge.js
var Badge = __webpack_require__(72522);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/CalendarCheck.js
var CalendarCheck = __webpack_require__(21045);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/HotelsFill.js
var HotelsFill = __webpack_require__(28845);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/highlightedFlex/HighlightedFlex.js
var HighlightedFlex = __webpack_require__(93894);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
;// CONCATENATED MODULE: ./src/utils/get-hotel-link.ts

function getHotelLink(destination, start, end, numRooms) {
    return "/relax/at/".concat(destination, "/from/").concat((0,format/* default */.Z)(start, "yyyyMMdd"), "/to/").concat((0,format/* default */.Z)(end, "yyyyMMdd"), "/rooms/").concat(numRooms, "?iscalendaropen=true");
}

;// CONCATENATED MODULE: ./src/components/ExtendStay/utils.ts
var FASTLY_VALUES = {
    opto: true,
    crop: "261:261,offset-y100",
    auto: "webp"
};
function toQueryString(params) {
    var encodeFields = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var queryStrings = Object.keys(params).map(function(key) {
        var encodeValue = encodeFields ? encodeURIComponent(params[key]) : params[key];
        return "".concat(key, "=").concat(encodeValue);
    });
    return queryStrings.join("&");
}
function generateHotelCoverPhotoUrl() {
    var hotelID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!hotelID) {
        return "";
    }
    var castedPropertyID = parseInt(hotelID, 10);
    var fPath = Math.floor(castedPropertyID / 100000);
    var sPath = Math.floor(castedPropertyID / 10000 - fPath * 10);
    var tPath = Math.floor(castedPropertyID / 1000 - (fPath * 10 + sPath) * 10);
    return "https://mobileimg.pclncdn.com/htlimg/master/".concat(fPath, "/").concat(sPath, "/").concat(tPath, "/").concat(hotelID, "/master_").concat(hotelID);
}
function generateThumbnailURL() {
    var hotelID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!hotelID) {
        return "";
    }
    var masterImageURL = generateHotelCoverPhotoUrl(hotelID);
    var fastlyQS = toQueryString(FASTLY_VALUES);
    return "".concat(masterImageURL, "?").concat(fastlyQS);
}
/* harmony default export */ var ExtendStay_utils = (generateThumbnailURL);

;// CONCATENATED MODULE: ./src/components/ExtendStay/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 4px solid ",
        ";\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var FlexWithTopBorder = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ca4c5fb3-0"
})(_templateObject(), (0,utils/* getPaletteColor */.ow)("primary.base"));
var CalendarIcon = (0,styled_components_browser_esm/* default */.ZP)(CalendarCheck/* default */.Z).withConfig({
    componentId: "sc-ca4c5fb3-1"
})(_templateObject1());
var HotelsFillIcon = (0,styled_components_browser_esm/* default */.ZP)(HotelsFill/* default */.Z).withConfig({
    componentId: "sc-ca4c5fb3-2"
})(_templateObject2());
var renderExtendStayButton = function(hotelID, endDate, numRooms) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: getHotelLink(hotelID, endDate, (0,addDays/* default */.Z)(endDate, 1), numRooms),
        onClick: function() {
            analytics/* default.fireEvent */.Z.fireEvent({
                action: "extend_trip",
                category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG
            });
        },
        variation: "fill",
        target: "_blank",
        children: "Extend your Stay"
    });
};
function ExtendStay(param) {
    var travelEndDateTime = param.travelEndDateTime, cityName = param.cityName, hotelID = param.hotelID, _numRooms = param.numRooms, numRooms = _numRooms === void 0 ? 1 : _numRooms, title = param.title, customerFirstName = param.customerFirstName;
    var endDate = (0,parseISO/* default */.Z)(travelEndDateTime);
    var formattedEndDate = (0,format/* default */.Z)(endDate, "EEE, MMM dd");
    var image = ExtendStay_utils(hotelID);
    var trackViewTripClick = function() {
        analytics/* default.fireEvent */.Z.fireEvent({
            action: "Feature Box Link",
            category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
            label: "Cross Sell View Trip"
        });
    };
    var tripTitle = customerFirstName ? "".concat(customerFirstName, ", here are your trip details") : "Here are your trip details";
    var sectionTitle = "".concat(tripTitle, ",  Extend your hotel stay in ").concat(cityName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HighlightedFlex/* HighlightedFlex */.z, {
        shadowOffsetX: 24,
        shadowOffsetY: 24,
        maxWidth: "1216px",
        "aria-label": sectionTitle,
        flexDirection: [
            "column",
            null,
            "row"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWithTopBorder, {
                flexDirection: "column",
                width: [
                    1,
                    null,
                    null,
                    4 / 11,
                    3 / 11
                ],
                p: 3,
                borderRadius: "xl",
                boxShadowSize: "sm",
                justifyContent: "center",
                color: "background.lightest",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text.heading",
                        textStyle: "heading2",
                        mb: 3,
                        children: tripTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                width: "88px",
                                borderRadius: "xl",
                                src: image,
                                mr: 3,
                                alt: "Picture of ".concat(title, ", ").concat(cityName)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        mb: 1,
                                        textStyle: "heading5",
                                        children: "".concat(title, ", ").concat(cityName)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        textStyle: "subheading6",
                                        children: "Check-out on ".concat(formattedEndDate)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/next-profile/trips",
                        onClick: trackViewTripClick,
                        variation: "fill",
                        children: "View Trip"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mt: "24px",
                py: 2,
                width: [
                    1,
                    null,
                    null,
                    7 / 11,
                    8 / 11
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            sm: true,
                            md: true,
                            lg: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                bg: "background.lightest",
                                borderRadius: "full",
                                color: "success.dark",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                p: "24px",
                                m: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelsFillIcon, {
                                    size: 5
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        justifyContent: "center",
                        ml: [
                            3,
                            null,
                            null,
                            null,
                            0
                        ],
                        mr: [
                            3,
                            null,
                            null,
                            1,
                            5
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge/* default */.Z, {
                                    bg: "highlight.light",
                                    color: "highlight.shade",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarIcon, {
                                            size: "14px",
                                            mr: 1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            pl: 3,
                                            children: "STAY LONGER"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                color: "text.heading",
                                mb: 3,
                                textStyle: [
                                    "heading4",
                                    null,
                                    null,
                                    "heading3"
                                ],
                                children: [
                                    "Extend your hotel stay in ",
                                    cityName,
                                    " & save even more with Priceline’s best available rates.*"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: 4,
                                children: renderExtendStayButton(hotelID, endDate, numRooms)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                color: "text.base",
                                textStyle: "disclaimer",
                                children: "* This will be a separate reservation. Your current reservation will remain unchanged and in rare cases, the hotel may require you to move rooms."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 60189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31883);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28845);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31452);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75749);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77681);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83976);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26102);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40165);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76023);
/* harmony import */ var _pcln_brand__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31499);





var icons = {
    hotels: {
        outline: _pcln_brand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        fill: _pcln_brand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
    },
    flights: {
        outline: _pcln_brand__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        fill: _pcln_brand__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
    },
    vacations: {
        outline: _pcln_brand__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
        fill: _pcln_brand__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
    },
    cars: {
        outline: _pcln_brand__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
        fill: _pcln_brand__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z
    },
    cruises: {
        outline: _pcln_brand__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
        fill: _pcln_brand__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z
    }
};
var ProductIcon = function(props) {
    var name = props.name, isActive = props.isActive, iconProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(props, [
        "name",
        "isActive"
    ]);
    var IconType = isActive ? icons[name].fill : icons[name].outline;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconType, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, iconProps));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductIcon);


/***/ }),

/***/ 25379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PromoFeatureBox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/highlightedFlex/HighlightedFlex.js
var HighlightedFlex = __webpack_require__(93894);
// EXTERNAL MODULE: ./src/components/Promos/MediaCard/MediaCardComponent.tsx + 1 modules
var MediaCardComponent = __webpack_require__(69582);
// EXTERNAL MODULE: ./src/hooks/useContentfulVariation.ts + 1 modules
var useContentfulVariation = __webpack_require__(49356);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/utils.ts
var utils = __webpack_require__(84822);
// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/Form.tsx + 8 modules
var Form = __webpack_require__(49515);
// EXTERNAL MODULE: ./src/components/Hotels/constants.ts
var constants = __webpack_require__(69722);
;// CONCATENATED MODULE: ./src/components/Promos/Pricebreakers/content.tsx






var modal = {
    contentTypeId: "modal",
    url: "",
    internalName: "modal",
    buttonText: "Search Pricebreakers",
    testId: "mobile-pricebreaker-button",
    ariaLabel: "Pricebreakers",
    analyticsTracking: {
        contentTypeId: "googleAnalyticsTracking",
        category: "PCLN_HOME",
        action: "Feature Box CTA",
        label: "Search VIP Deals"
    },
    modalContent: {
        contentTypeId: "modal",
        internalName: "modal",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            p: [
                3,
                0
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: [
                    0,
                    3
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            3,
                            null,
                            null,
                            5
                        ],
                        fontWeight: "bold",
                        style: {
                            lineHeight: 1.25
                        },
                        children: "Search Pricebreakers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            1,
                            null,
                            null,
                            4
                        ],
                        style: {
                            lineHeight: 1.25
                        },
                        mb: 3,
                        children: "Our highest rated hotels - up to 50% off retail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pb: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                            onSubmit: utils/* handleSubmitForPricebreakers */.nz,
                            promoDeal: constants/* PromoDeal.COLLECTIONS */.cS.COLLECTIONS
                        })
                    })
                ]
            })
        })
    }
};
var CONTENT = {
    contentTypeId: "mediaCard",
    internalName: "Media Card",
    overline: "",
    heading: "Save up to 50% off hotels with Pricebreakers",
    subheading: "See 3 popular hotels at a heavily discounted price. See 3 popular hotels at a heavily discounted price. See 3 popular hotels at a heavily discounted price.",
    media: {
        title: "pricebreakers image",
        description: "",
        file: {
            url: "https://s1.pclncdn.com/design-assets/home/promos/Pricebreakers.jpg",
            details: {
                size: 925398,
                image: {
                    width: 1200,
                    height: 400
                }
            },
            fileName: "Pricebreakers.jpg",
            contentType: "image/jpeg"
        }
    },
    primaryCallToAction: modal
};
/* harmony default export */ var content = (CONTENT);

;// CONCATENATED MODULE: ./src/components/Promos/Pricebreakers/PriceBreakersMediaCard.tsx





function PriceBreakersMediaCard() {
    var promo = (0,useContentfulVariation/* default */.Z)("leftPromoBox");
    var hasContentfulData = promo != null;
    var mediaCardContent = hasContentfulData ? promo : content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCardComponent/* default */.Z, {
            content: mediaCardContent
        })
    });
}

// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/constants/content.ts
var constants_content = __webpack_require__(66410);
;// CONCATENATED MODULE: ./src/components/Promos/VIP/content.tsx






var content_modal = {
    contentTypeId: "modal",
    url: "",
    internalName: "modal",
    buttonText: "Search VIP Deals",
    ariaLabel: "Search VIP Deals",
    analyticsTracking: {
        contentTypeId: "googleAnalyticsTracking",
        category: "PCLN_HOME",
        action: "Feature Box CTA",
        label: "Search VIP Deals"
    },
    modalContent: {
        contentTypeId: "modal",
        internalName: "modal",
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            p: [
                3,
                0
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                px: [
                    0,
                    3
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            3,
                            null,
                            null,
                            5
                        ],
                        fontWeight: "bold",
                        style: {
                            lineHeight: 1.25
                        },
                        children: "Search VIP Deals"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        color: "text",
                        fontSize: [
                            1,
                            null,
                            null,
                            4
                        ],
                        style: {
                            lineHeight: 1.25
                        },
                        mb: 3,
                        children: "Save more as a Priceline VIP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pb: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                            onSubmit: utils/* handleSubmitForVIPDeals */.ty,
                            promoDeal: constants/* PromoDeal.VIP */.cS.VIP
                        })
                    })
                ]
            })
        })
    }
};
var content_CONTENT = {
    contentTypeId: "mediaCard",
    internalName: "Media Card",
    overline: "",
    heading: "",
    subheading: "'Book Priceline VIP deals for your exclusive savings",
    media: {
        title: "vip image",
        description: "",
        file: {
            url: "https://s1.pclncdn.com/design-assets/home/promos/VIP.png",
            details: {
                size: 925398,
                image: {
                    width: 1200,
                    height: 400
                }
            },
            fileName: "vip.png",
            contentType: "image/jpeg"
        }
    },
    primaryCallToAction: content_modal
};
/* harmony default export */ var VIP_content = (content_CONTENT);

;// CONCATENATED MODULE: ./src/components/Promos/VIP/VIPPromoMediaCard.tsx







function VIPPromoMediaCard() {
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), firstName = ref.customer.firstName;
    var promo = (0,useContentfulVariation/* default */.Z)("leftPromoBox");
    var hasContentfulData = promo != null;
    var headlineVIP = firstName ? constants_content/* default.homepage.vip.promo.headlineWithName.replace */.ZP.homepage.vip.promo.headlineWithName.replace("{firstName}", firstName) : constants_content/* default.homepage.vip.promo.headline */.ZP.homepage.vip.promo.headline;
    VIP_content.heading = headlineVIP;
    var mediaCardContent = hasContentfulData ? promo : VIP_content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCardComponent/* default */.Z, {
            content: mediaCardContent
        })
    });
}

// EXTERNAL MODULE: ./src/components/Promos/IncredibleTile/IncredibleTileMediaCard.tsx + 1 modules
var IncredibleTileMediaCard = __webpack_require__(20977);
// EXTERNAL MODULE: ./node_modules/@pcln/feature-components/dist/esm/useFeature/useFeature.js
var useFeature = __webpack_require__(66252);
;// CONCATENATED MODULE: ./src/components/PromoFeatureBox.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var HighlightedFlexStyle = (0,styled_components_browser_esm/* default */.ZP)(HighlightedFlex/* HighlightedFlex */.z).withConfig({
    componentId: "sc-3895eae5-0"
})(_templateObject());
function PromoFeatureBox() {
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _signInStatus = ref.signInStatus, _signedIn = _signInStatus.signedIn, signedIn = _signedIn === void 0 ? false : _signedIn;
    var heroSpacing = isMobile ? {
        my: [
            1,
            null,
            4
        ]
    } : {
        mt: [
            1,
            null,
            null,
            -4,
            0
        ],
        mb: [
            1,
            null,
            4
        ],
        style: {
            position: "relative"
        }
    };
    var highlightColor = (0,useFeature/* default */.Z)("siteExperience.highlightColor");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        mx: "auto",
        justifyContent: "center"
    }, heroSpacing), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedFlexStyle, {
            shadowOffsetX: 24,
            shadowOffsetY: 24,
            maxWidth: 1216,
            flexWrap: [
                "wrap",
                null,
                "unset"
            ],
            shadowColor: highlightColor,
            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IncredibleTileMediaCard/* default */.Z, {
                        contentFulFieldID: "incredibleTile"
                    }),
                    signedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VIPPromoMediaCard, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceBreakersMediaCard, {})
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    signedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VIPPromoMediaCard, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceBreakersMediaCard, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IncredibleTileMediaCard/* default */.Z, {
                        contentFulFieldID: "incredibleTile"
                    })
                ]
            })
        })
    }));
}


/***/ }),

/***/ 20977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IncredibleTileMediaCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useContentfulVariation.ts + 1 modules
var useContentfulVariation = __webpack_require__(49356);
// EXTERNAL MODULE: ./src/components/Promos/MediaCard/MediaCardComponent.tsx + 1 modules
var MediaCardComponent = __webpack_require__(69582);
;// CONCATENATED MODULE: ./src/components/Promos/IncredibleTile/contentMediaCard.ts
var CONTENT = {
    contentTypeId: "mediaCard",
    internalName: "Media Card",
    overline: "",
    heading: "10% off coupon",
    subheading: "Book anything today and get 10% off your next Express Deal\xae Hotel",
    media: {
        title: "Incredible Tile Promo",
        description: "",
        file: {
            url: "https://s1.pclncdn.com/design-assets/home/promos/IncredibleTile.jpg",
            details: {
                size: 925398,
                image: {
                    width: 1200,
                    height: 400
                }
            },
            fileName: "IncredibleTile.jpg",
            contentType: "image/jpeg"
        }
    },
    primaryCallToAction: undefined
};
/* harmony default export */ var contentMediaCard = (CONTENT);

;// CONCATENATED MODULE: ./src/components/Promos/IncredibleTile/IncredibleTileMediaCard.tsx





function IncredibleTileMediaCard(param) {
    var contentFulFieldID = param.contentFulFieldID;
    var promo = (0,useContentfulVariation/* default */.Z)(contentFulFieldID);
    var hasContentfulData = promo != null;
    var mediaCardContent = hasContentfulData ? promo : contentMediaCard;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCardComponent/* default */.Z, {
        content: mediaCardContent
    });
}


/***/ }),

/***/ 51453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MarketingTout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useContentfulVariation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49356);
/* harmony import */ var _MerchModuleWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73779);




function MarketingTout() {
    var marketingTout = (0,_hooks_useContentfulVariation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("marketingTout");
    return marketingTout != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MerchModuleWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        content: marketingTout
    }) : null;
}


/***/ }),

/***/ 69582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MediaCardComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/MediaCard/MediaCard.js + 1 modules
var MediaCard = __webpack_require__(51100);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/MoreInfo/MoreInfo.js
var MoreInfo = __webpack_require__(62818);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/ContentfulRichText/ContentfulRichText.js + 6 modules
var ContentfulRichText = __webpack_require__(77626);
;// CONCATENATED MODULE: ./src/components/Promos/Modal/MoreInfoModal.tsx





var MoreInfoModal = function(param) {
    var heading = param.heading, paragraph = param.paragraph, body = param.body, disclaimer = param.disclaimer, primaryCallToAction = param.primaryCallToAction, secondaryCallToAction = param.secondaryCallToAction, isOpen = param.isOpen, handleClose = param.handleClose, isFullHeight = param.isFullHeight;
    var bodyContent = function() {
        if (body) {
            return body;
        }
        if (paragraph) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
                body: paragraph
            });
        }
        return null;
    };
    var modalProps = {
        heading: heading,
        isFullHeight: isFullHeight,
        body: bodyContent(),
        disclaimer: disclaimer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulRichText/* default */.Z, {
            body: disclaimer
        }) : null,
        primaryCallToAction: primaryCallToAction,
        secondaryCallToAction: secondaryCallToAction,
        isOpen: isOpen,
        onClose: handleClose,
        withModal: true,
        enableOverflow: true,
        disableCloseButton: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfo/* default */.Z, (0,_object_spread/* default */.Z)({}, modalProps));
};
/* harmony default export */ var Modal_MoreInfoModal = (MoreInfoModal);

;// CONCATENATED MODULE: ./src/components/Promos/MediaCard/MediaCardComponent.tsx








function MediaCardComponent(param) {
    var content = param.content;
    var ref;
    var heading = content.heading, overline = content.overline, subheading = content.subheading, media = content.media, analyticsTracking = content.analyticsTracking, primaryCallToAction = content.primaryCallToAction;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(), currentModalProps = ref2[0], setCurrentModalProps = ref2[1];
    var handleOpen = function(modalProps, gaTracking) {
        if ((gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.category) && (gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.action) && (gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.label)) {
            var gaParams = {
                category: gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.category,
                action: gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.action,
                label: gaTracking === null || gaTracking === void 0 ? void 0 : gaTracking.label
            };
            analytics/* default.fireEvent */.Z.fireEvent(gaParams);
        }
        if (modalProps) {
            setCurrentModalProps(modalProps);
            setIsOpen(true);
        }
    };
    var handleClose = function() {
        setCurrentModalProps(undefined);
        setIsOpen(false);
    };
    (0,react.useEffect)(function() {
        if ((analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.action) && (analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.label)) {
            analytics/* default.fireEvent */.Z.fireEvent({
                category: analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.category,
                action: analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.action,
                label: analyticsTracking === null || analyticsTracking === void 0 ? void 0 : analyticsTracking.label
            });
        }
    }, [
        analyticsTracking
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_MoreInfoModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentModalProps), {
                isFullHeight: false,
                isOpen: isOpen,
                handleClose: function() {
                    handleClose();
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                borderWidth: 0,
                width: [
                    1,
                    null,
                    1 / 2
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCard/* default */.Z, {
                    handleOpen: handleOpen,
                    asset: {
                        file: {
                            contentType: "Image",
                            details: {
                                image: {
                                    height: 200,
                                    width: 600
                                }
                            },
                            fileName: media === null || media === void 0 ? void 0 : (ref = media.file) === null || ref === void 0 ? void 0 : ref.fileName,
                            url: media === null || media === void 0 ? void 0 : media.file.url
                        },
                        title: media === null || media === void 0 ? void 0 : media.title
                    },
                    callToAction: primaryCallToAction,
                    heading: heading,
                    overline: overline,
                    subheading: subheading,
                    objectFit: "cover",
                    objectPosition: "top"
                })
            })
        ]
    });
}


/***/ }),

/***/ 90924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SmsOptInComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@pcln/sms-opt-in/dist/esm/index.js + 5 modules
var esm = __webpack_require__(80111);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@pcln/request/dist/esm/index.js
var dist_esm = __webpack_require__(37947);
var esm_default = /*#__PURE__*/__webpack_require__.n(dist_esm);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./node_modules/isomorphic-config/lib/config.js
var config = __webpack_require__(82197);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/constants/sms-disclaimer-text.ts
/* harmony default export */ var sms_disclaimer_text = ([
    {
        optinStatus: null,
        disclaimerText: [
            {
                text: "*By clicking 'subscribe', you agree to receive promotional and personalized marketing text messages from Priceline to the mobile number provided during sign-up. Messages may be sent using an automatic telephone dialing system. Consent is not required as a condition of purchase. Reply STOP at any time to cancel. Msg frequency varies. Msg and data rates may apply. Offer only valid for customers with U.S. phone numbers. Applicable terms and privacy policy available at: ",
                url: null
            },
            {
                text: "terms",
                url: "https://www.priceline.com/static-pages/terms_en.html"
            },
            {
                text: " & ",
                url: null
            },
            {
                text: "privacy",
                url: "https://www.priceline.com/static-pages/privacy-policy.html"
            },
            {
                text: ".",
                url: null
            }
        ]
    }
]);

;// CONCATENATED MODULE: ./src/hooks/smsOptIn/useGetDisclaimer.ts








var useGetDisclaimer = function(baseParams) {
    var ref = (0,react.useState)(sms_disclaimer_text), disclaimers = ref[0], setDisclaimers = ref[1];
    (0,react.useEffect)(function() {
        function fetchSmsDisclaimer() {
            return _fetchSmsDisclaimer.apply(this, arguments);
        }
        function _fetchSmsDisclaimer() {
            _fetchSmsDisclaimer = (0,_async_to_generator/* default */.Z)(function() {
                var ref, url, timeout, response, _data, errors, data, errorMessage, ref1, ref2, error, errorMessage1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            ref = (config_default()).client["pcln-graph"], url = ref.url, timeout = ref.timeout;
                            return [
                                4,
                                esm_default()({
                                    url: url,
                                    timeout: timeout,
                                    method: "POST",
                                    data: {
                                        query: baseParams.query,
                                        variables: baseParams.disclaimerParams
                                    }
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            _data = response.data, errors = _data.errors, data = _data.data;
                            if (Array.isArray(errors) && errors.length > 0) {
                                errorMessage = (0,_instanceof/* default */.Z)(errors, Error) ? errors.message : errors.toString();
                                analytics/* default.logError */.Z.logError({
                                    message: "Failed to enroll for SMS subscription for cGuid: ".concat(baseParams.clientGUID, " Error message: ").concat(errorMessage)
                                });
                                return [
                                    2
                                ];
                            }
                            if (data) {
                                ;
                                // TODO remove success log in seti cleanup. seti: HP_SMS_COMPONENT
                                analytics/* default.log */.Z.log({
                                    message: "Fetched disclaimer for cGuid: ".concat(baseParams.clientGUID)
                                });
                                setDisclaimers(((ref1 = data.smsDisclaimerTextByEmail) === null || ref1 === void 0 ? void 0 : ref1.disclaimers) || ((ref2 = data.smsDisclaimerText) === null || ref2 === void 0 ? void 0 : ref2.disclaimers));
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            errorMessage1 = (0,_instanceof/* default */.Z)(error, Error) ? error.message : error.toString();
                            analytics/* default.logError */.Z.logError({
                                message: "Failed to query for SMS disclaimer text for cGuid: ".concat(baseParams.clientGUID, ". Error message: ").concat(errorMessage1)
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchSmsDisclaimer.apply(this, arguments);
        }
        fetchSmsDisclaimer();
    }, [
        baseParams
    ]);
    return disclaimers;
};
/* harmony default export */ var smsOptIn_useGetDisclaimer = (useGetDisclaimer);

// EXTERNAL MODULE: ./src/utils/queries/smsOptIn.ts
var smsOptIn = __webpack_require__(20451);
;// CONCATENATED MODULE: ./src/hooks/smsOptIn/useSubmitSmsOptIn.ts







function isEmailResponse(data, emailAddress) {
    return !!emailAddress;
}
var fireAnalytics = function(label) {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "sms signup",
        category: "pcln_home",
        label: label
    });
};
function handleSubmit(_) {
    return _handleSubmit.apply(this, arguments);
}
function _handleSubmit() {
    _handleSubmit = (0,_async_to_generator/* default */.Z)(function(param) {
        var emailAddress, formData, disclaimerText, baseParams, setSignUpState, setSignUpSubmitFailureMessage, clientGUID, createSubmission, ref, url, timeout, response, _data, errors, data, status, message, ref1, ref2, ref3, ref4, error, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    emailAddress = param.emailAddress, formData = param.formData, disclaimerText = param.disclaimerText, baseParams = param.baseParams, setSignUpState = param.setSignUpState, setSignUpSubmitFailureMessage = param.setSignUpSubmitFailureMessage, clientGUID = param.clientGUID;
                    setSignUpState("SIGN_UP_IN_PROGRESS");
                    createSubmission = function() {
                        return emailAddress ? {
                            emailAddress: emailAddress,
                            phoneCountryCode: formData.phoneCountryCode,
                            phoneNumber: formData.phoneNumber,
                            subscriptionBaseParam: {
                                subscriptionTypeId: 1,
                                disclaimerText: disclaimerText,
                                subscriptionStatus: true,
                                placement: baseParams.disclaimerBaseParam.placement,
                                appCode: baseParams.disclaimerBaseParam.appCode,
                                plfCode: baseParams.disclaimerBaseParam.PLFCode
                            }
                        } : {
                            phoneCountryCode: formData.phoneCountryCode,
                            phoneNumber: formData.phoneNumber,
                            subscriptionBaseParam: {
                                subscriptionTypeId: 1,
                                disclaimerText: disclaimerText,
                                subscriptionStatus: true,
                                placement: baseParams.disclaimerBaseParam.placement,
                                appCode: baseParams.disclaimerBaseParam.appCode,
                                plfCode: baseParams.disclaimerBaseParam.PLFCode
                            }
                        };
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    ref = (config_default()).client["pcln-graph"], url = ref.url, timeout = ref.timeout;
                    return [
                        4,
                        esm_default()({
                            url: url,
                            timeout: timeout,
                            method: "POST",
                            data: {
                                query: emailAddress ? smsOptIn/* SMS_SUBMIT_WITH_EMAIL_MUTATION */.A9 : smsOptIn/* SMS_SUBMIT_NO_EMAIL_MUTATION */.Yw,
                                variables: createSubmission()
                            }
                        })
                    ];
                case 2:
                    response = _state.sent();
                    _data = response.data, errors = _data.errors, data = _data.data;
                    status = "";
                    message = "";
                    if (data) {
                        ;
                        status = isEmailResponse(data, emailAddress) ? (ref1 = data.smsSubscriptionByEmailAddress) === null || ref1 === void 0 ? void 0 : ref1.status : (ref2 = data.smsSubscriptionByPhoneNumber) === null || ref2 === void 0 ? void 0 : ref2.status;
                        message = isEmailResponse(data, emailAddress) ? (ref3 = data.smsSubscriptionByEmailAddress) === null || ref3 === void 0 ? void 0 : ref3.message : (ref4 = data.smsSubscriptionByPhoneNumber) === null || ref4 === void 0 ? void 0 : ref4.message;
                    }
                    if (Array.isArray(errors) && errors.length > 0) {
                        analytics/* default.logError */.Z.logError({
                            message: "Failed to enroll for SMS subscription for cGuid: ".concat(clientGUID, "  Error status: ").concat(status, ", Error message: ").concat(message)
                        });
                        fireAnalytics("invalid");
                        setSignUpState("SIGN_UP_ERROR");
                        return [
                            2
                        ];
                    }
                    if (status === "BAD_REQUEST") {
                        analytics/* default.logError */.Z.logError({
                            message: "Failed to enroll for SMS subscription for cGuid: ".concat(clientGUID, "  Error status: ").concat(status, ", Error message: ").concat(message)
                        });
                        setSignUpSubmitFailureMessage(message);
                        fireAnalytics("invalid");
                        setSignUpState("NOT_SIGNED_UP");
                        return [
                            2
                        ];
                    }
                    if (status !== "SUCCESS" && status !== "PENDING") {
                        analytics/* default.logError */.Z.logError({
                            message: "Failed to enroll for SMS subscription for cGuid: ".concat(clientGUID, "  Error status: ").concat(status, ", Error message: ").concat(message)
                        });
                        fireAnalytics("invalid");
                        setSignUpState("SIGN_UP_ERROR");
                        return [
                            2
                        ];
                    }
                    // TODO remove success log in seti cleanup. seti: HP_SMS_COMPONENT
                    analytics/* default.log */.Z.log({
                        message: "Successful SMS subscription for cGuid: ".concat(clientGUID, " status: ").concat(status)
                    });
                    fireAnalytics("valid");
                    setSignUpState("SIGNED_UP");
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    errorMessage = (0,_instanceof/* default */.Z)(error, Error) ? error.message : error.toString();
                    analytics/* default.logError */.Z.logError({
                        message: "Failed to enroll for SMS subscription for cGuid: ".concat(clientGUID, " Error message: ").concat(errorMessage)
                    });
                    fireAnalytics("invalid");
                    setSignUpState("SIGN_UP_ERROR");
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleSubmit.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/components/SmsOptIn/index.tsx







var imageUrl = "https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&dpr=2&orient=2&width=256&crop=3:2,smart";
var altImageText = "business man in car";
var smallImageUrl = "https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&dpr=2&orient=2&width=256&crop=2:3,smart";
var smallImageAltText = "business man in car";
var headline = "NEW: Get savings texted to you directly!";
var subheadline = "Provide your phone number and we'll send you special deals and promotions via SMS.";
function SmsOptInComponent(param) {
    var disclaimerQueryArgs = param.disclaimerQueryArgs;
    var ref, ref1;
    var ref2 = (0,react.useContext)(BootstrapDataContext/* default */.Z), isMobile = ref2.isMobile, clientGUID = ref2.webstats.clientGUID;
    var emailAddress = disclaimerQueryArgs.disclaimerParams.emailAddress;
    var disclaimers = smsOptIn_useGetDisclaimer(disclaimerQueryArgs);
    var baseParams = disclaimerQueryArgs.disclaimerParams;
    var ref3 = (0,react.useState)("NOT_SIGNED_UP"), signUpState = ref3[0], setSignUpState = ref3[1];
    var ref4 = (0,react.useState)(""), signUpSubmitFailureMessage = ref4[0], setSignUpSubmitFailureMessage = ref4[1];
    var validDisclaimer = disclaimers === null || disclaimers === void 0 ? void 0 : disclaimers.find(function(disclaimer) {
        return !disclaimer.optinStatus;
    });
    var disclaimerText = validDisclaimer === null || validDisclaimer === void 0 ? void 0 : (ref = validDisclaimer.disclaimerText) === null || ref === void 0 ? void 0 : ref.reduce(function(previousValue, currentValue) {
        return previousValue + currentValue.text;
    }, "");
    var disclaimerTextNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: validDisclaimer === null || validDisclaimer === void 0 ? void 0 : (ref1 = validDisclaimer.disclaimerText) === null || ref1 === void 0 ? void 0 : ref1.map(function(param, index) {
            var text = param.text, url = param.url;
            var uniqueKey = isMobile ? "m".concat(index) : "d".concat(index);
            return url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: url,
                target: "blank",
                children: text
            }, uniqueKey) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: text
            }, uniqueKey);
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: validDisclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: 1280,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                borderRadius: "xl",
                mx: [
                    0,
                    null,
                    null,
                    null,
                    4
                ],
                mt: [
                    0,
                    null,
                    null,
                    null,
                    "40px"
                ],
                mb: [
                    3,
                    null,
                    null,
                    null,
                    0
                ],
                p: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                    headline: headline,
                    subheadline: subheadline,
                    imageUrl: imageUrl,
                    smallImageUrl: smallImageUrl,
                    buttonSize: "large",
                    textInputRadius: "lg",
                    signUpState: signUpState,
                    imageWidth: 1 / 3,
                    formWidth: 2 / 3,
                    disclaimerTextNode: disclaimerTextNode,
                    handleFormSubmit: function(formData) {
                        return handleSubmit({
                            emailAddress: emailAddress,
                            formData: formData,
                            disclaimerText: disclaimerText || "",
                            baseParams: baseParams,
                            setSignUpState: setSignUpState,
                            setSignUpSubmitFailureMessage: setSignUpSubmitFailureMessage,
                            clientGUID: clientGUID
                        });
                    },
                    phoneInputErrorMessage: signUpSubmitFailureMessage,
                    altImageText: altImageText,
                    smallImageAltText: smallImageAltText
                })
            })
        })
    });
}


/***/ }),

/***/ 69325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94738);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66487);


/* harmony default export */ __webpack_exports__["Z"] = ({
    headline: "Introducing Priceline Experiences",
    subheadline: "Discover and book over 80,000 in-destination travel activities in more than 100 countries worldwide!",
    badgeText: "NEW!",
    callToAction: {
        text: "Explore Now",
        url: "https://experiences.priceline.com/?cid=hpgbanner",
        ariaLabel: "marketingCTA"
    },
    onClick: function() {
        _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_0__/* ["default"].fireEvent */ .Z.fireEvent({
            action: "branded marketing component",
            category: _analytics__WEBPACK_IMPORTED_MODULE_1__/* .ANALYTICS_CATEGORY_HOME */ .DG,
            label: "experiences click"
        });
    },
    imageUrl: "https://s1.pclncdn.com/design-assets/brand-assets/experiences1.jpg?opto&crop=600,420,x200,safe,smart"
});


/***/ }),

/***/ 95846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSmsDisclaimerQueryArgs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);
/* harmony import */ var _shared_utils_queries_smsOptIn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20451);




var baseParamsMobile = {
    disclaimerBaseParam: {
        placement: "HOMEPAGE",
        appCode: "MOBILEWEB",
        classification: "PROMOTIONAL",
        PLFCode: "PCLN"
    }
};
var baseParamsDesktop = {
    disclaimerBaseParam: {
        placement: "HOMEPAGE",
        appCode: "DESKTOP",
        classification: "PROMOTIONAL",
        PLFCode: "PCLN"
    }
};
function useSmsDisclaimerQueryArgs() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), emailAddress = ref.customer.emailAddress, _signInStatus = ref.signInStatus, signedIn = _signInStatus.signedIn, passiveSignIn = _signInStatus.passiveSignIn, isMobile = ref.isMobile, clientGUID = ref.webstats.clientGUID;
    var smsQueryArgs = isMobile ? baseParamsMobile : baseParamsDesktop;
    var emailParams = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        emailAddress: emailAddress
    }, smsQueryArgs);
    return (signedIn || passiveSignIn) && emailAddress ? {
        disclaimerParams: emailParams,
        clientGUID: clientGUID,
        query: _shared_utils_queries_smsOptIn__WEBPACK_IMPORTED_MODULE_3__/* .SMS_DISCLAIMER_TEXT_BY_EMAIL_QUERY */ .QQ
    } : {
        query: _shared_utils_queries_smsOptIn__WEBPACK_IMPORTED_MODULE_3__/* .SMS_DISCLAIMER_TEXT_QUERY */ .nj,
        clientGUID: clientGUID,
        disclaimerParams: smsQueryArgs
    };
}


/***/ }),

/***/ 83405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useExtendStayBooking; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);


function useExtendStayBooking() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), mostRecentBooking = ref.mostRecentBooking, customer = ref.customer;
    var extendStayTrip = mostRecentBooking === null || mostRecentBooking === void 0 ? void 0 : mostRecentBooking.current;
    return extendStayTrip ? {
        travelEndDateTime: extendStayTrip.travelEndDateTime,
        cityName: extendStayTrip.cityName,
        hotelID: extendStayTrip.hotelID,
        numRooms: extendStayTrip.numRooms,
        title: extendStayTrip.title,
        customerFirstName: customer.firstName
    } : null;
}


/***/ }),

/***/ 81850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMostRecentFutureBooking; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67763);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68464);



var isTruthy = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .complement */ .CyQ)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .either */ .wEe)(ramda__WEBPACK_IMPORTED_MODULE_1__/* .isNil */ .kKJ, ramda__WEBPACK_IMPORTED_MODULE_1__/* .isEmpty */ .xbD));
function useMostRecentFutureBooking() {
    var mostRecentBooking = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).mostRecentBooking;
    return isTruthy(mostRecentBooking === null || mostRecentBooking === void 0 ? void 0 : mostRecentBooking.future) ? mostRecentBooking === null || mostRecentBooking === void 0 ? void 0 : mostRecentBooking.future : null;
}


/***/ }),

/***/ 20451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ SMS_SUBMIT_WITH_EMAIL_MUTATION; },
/* harmony export */   "QQ": function() { return /* binding */ SMS_DISCLAIMER_TEXT_BY_EMAIL_QUERY; },
/* harmony export */   "Yw": function() { return /* binding */ SMS_SUBMIT_NO_EMAIL_MUTATION; },
/* harmony export */   "nj": function() { return /* binding */ SMS_DISCLAIMER_TEXT_QUERY; }
/* harmony export */ });
var SMS_DISCLAIMER_TEXT_QUERY = "\nquery smsDisclaimerText ($disclaimerBaseParam: DisclaimerBaseParam!) {\n  smsDisclaimerText(disclaimerBaseParam: $disclaimerBaseParam) {\n    message\n    status\n      disclaimers {\n        optinStatus\n        disclaimerText {\n          text\n          url\n        }\n      }\n    }\n}\n";
var SMS_DISCLAIMER_TEXT_BY_EMAIL_QUERY = "\nquery smsDisclaimerTextByEmail ($disclaimerBaseParam: DisclaimerBaseParam!, $emailAddress: String!) {\n  smsDisclaimerTextByEmail(disclaimerBaseParam: $disclaimerBaseParam, emailAddress: $emailAddress) {\n      message\n      status\n      disclaimers {\n        optinStatus\n        disclaimerText {\n          text\n          url\n        }\n      }\n    }\n}\n";
var SMS_SUBMIT_NO_EMAIL_MUTATION = "mutation smsSubscriptionByPhoneNumber ($phoneCountryCode: String!, $phoneNumber: String!, $subscriptionBaseParam: SubscriptionBaseParam!) {\n    smsSubscriptionByPhoneNumber (phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber, subscriptionBaseParam: $subscriptionBaseParam) {\n      message\n      status\n    }\n  }";
var SMS_SUBMIT_WITH_EMAIL_MUTATION = "mutation smsSubscriptionByEmailAddress ($emailAddress: String!, $phoneCountryCode: String!, $phoneNumber: String!, $subscriptionBaseParam: SubscriptionBaseParam!) {\n  smsSubscriptionByEmailAddress (emailAddress: $emailAddress, phoneCountryCode: $phoneCountryCode, phoneNumber: $phoneNumber, subscriptionBaseParam: $subscriptionBaseParam) {\n    message\n    status\n  }\n}";


/***/ })

}]);